/* Blazing Banner — design-from-scratch editor.
   Full-screen artboard shaped to the banner's size: background color, text with
   Google fonts, shapes and images. "Use this design" feeds a preview PNG into the
   builder like an upload and stores the editable layout on the banner, so
   bb-print-file.js can re-render it sharp at full print size.
   Layout units: 10 units = 1 inch of banner. Fabric.js loads on first open. */
(function () {
  'use strict';

  var FABRIC_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/fabric.js/5.3.1/fabric.min.js';
  var UPI = 10;          // layout units per inch
  var SAFE_IN = 1;       // hem fold: keep words inside this thin line
  var GROMMET_CLEAR_IN = 0.75; // keep-clear radius around each grommet center (grommets sit 3/4" in)
  var PREVIEW_SIDE = 2400;
  var SAVE_PROPS = ['bbSrcW', 'bbSrcH', 'bbKind', 'bbEl', 'bbFree'];

  // 30 Google fonts picked for banners, grouped so people can scan by feel.
  var FONT_GROUPS = [
    { label: 'Bold headlines', fonts: ['Anton', 'Bebas Neue', 'Oswald', 'Archivo Black', 'Bowlby One', 'Titan One', 'Alfa Slab One', 'Staatliches', 'Teko', 'Russo One'] },
    { label: 'Clean & modern', fonts: ['Montserrat', 'Poppins', 'Roboto', 'Open Sans', 'Lato', 'Raleway', 'Josefin Sans', 'Rubik'] },
    { label: 'Classic', fonts: ['Playfair Display', 'Merriweather', 'Abril Fatface'] },
    { label: 'Fun & loud', fonts: ['Bangers', 'Luckiest Guy', 'Black Ops One'] },
    { label: 'Script & handwritten', fonts: ['Pacifico', 'Lobster', 'Dancing Script', 'Great Vibes', 'Kaushan Script', 'Permanent Marker'] }
  ];
  var FONTS = FONT_GROUPS.reduce(function (all, g) { return all.concat(g.fonts); }, []);
  var FONT_CSS = 'https://fonts.googleapis.com/css2?' + [
    'Anton', 'Bebas+Neue', 'Oswald:wght@400;600;700', 'Archivo+Black', 'Bowlby+One', 'Titan+One', 'Alfa+Slab+One',
    'Staatliches', 'Teko:wght@500;600;700', 'Russo+One',
    'Montserrat:ital,wght@0,400;0,700;0,900;1,400;1,700',
    'Poppins:ital,wght@0,400;0,700;0,900;1,400;1,700',
    'Roboto:ital,wght@0,400;0,700;0,900;1,400;1,700',
    'Open+Sans:ital,wght@0,400;0,700;1,400;1,700',
    'Lato:ital,wght@0,400;0,700;0,900;1,400;1,700',
    'Raleway:ital,wght@0,400;0,700;0,900;1,400;1,700',
    'Josefin+Sans:ital,wght@0,400;0,700;1,400;1,700',
    'Rubik:ital,wght@0,400;0,700;0,900;1,400;1,700',
    'Playfair+Display:ital,wght@0,400;0,700;0,900;1,400;1,700',
    'Merriweather:ital,wght@0,400;0,700;0,900;1,400;1,700',
    'Abril+Fatface', 'Bangers', 'Luckiest+Guy', 'Black+Ops+One',
    'Pacifico', 'Lobster', 'Dancing+Script:wght@400;700', 'Great+Vibes', 'Kaushan+Script', 'Permanent+Marker'
  ].map(function (f) { return 'family=' + f; }).join('&') + '&display=swap';

  // Full-color vector graphics library (theme assets bb-el-<id>.svg), grouped as
  // { label, items: [ids] }. Empty for now: the first set was pulled on 2026-09-25 to be redesigned.
  // Designs that already used one keep working (their vector paths are saved in the design).
  var ELEMENT_GROUPS = [];
  function elementUrl(id) {
    var r = document.getElementById('blazing-banner-builder-v43');
    var sample = (r && r.getAttribute('data-bbd-el')) || '';
    return sample ? sample.replace(/bb-el-starburst\.svg(\?.*)?$/, 'bb-el-' + id + '.svg') : '';
  }
  function elementLabel(id) { return id.replace(/-/g, ' '); }

  // Simple one-color icons (single filled paths on a 24×24 grid so they recolor with one Fill).
  var GRAPHICS = [
    ['star', 'Star', 'M12 2l2.9 6.9 7.1.6-5.4 4.7 1.7 7.3L12 17.8 5.7 21.5l1.7-7.3L2 9.5l7.1-.6z'],
    ['heart', 'Heart', 'M12 21s-7.5-4.6-9.6-9.2C.9 8.4 3 4.5 6.7 4.5c2.1 0 3.6 1.1 5.3 3 1.7-1.9 3.2-3 5.3-3 3.7 0 5.8 3.9 4.3 7.3C19.5 16.4 12 21 12 21z'],
    ['check', 'Check', 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1.2 14.2L6.3 11.7l1.6-1.6 2.9 2.9 5.3-5.3 1.6 1.6z'],
    ['arrow', 'Arrow', 'M2 9h12V4l8 8-8 8v-5H2z'],
    ['bolt', 'Lightning', 'M13 2L4 14h6l-1 8 9-12h-6z'],
    ['flame', 'Flame', 'M12 1c1 4 6 6.5 6 12.5A6.5 6.5 0 0 1 11.5 20 6 6 0 0 1 6 14c0-2.7 1.4-4.6 3-6 0 2 .8 3.3 2 3.8C10.8 8 10.3 4.5 12 1z'],
    ['phone', 'Phone', 'M6.6 10.8a15.1 15.1 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.25 11.4 11.4 0 0 0 3.6.57 1 1 0 0 1 1 1V20a1 1 0 0 1-1 1A17 17 0 0 1 3 4a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.25.2 2.45.57 3.57a1 1 0 0 1-.25 1z'],
    ['pin', 'Location', 'M12 2a7 7 0 0 0-7 7c0 5.2 7 13 7 13s7-7.8 7-13a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z'],
    ['clock', 'Clock', 'M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 10.4l3.5 2.1-.9 1.5L11 13.2V6h2z'],
    ['calendar', 'Calendar', 'M7 2h2v3h6V2h2v3h3v16H4V5h3zM6 10v9h12v-9z'],
    ['house', 'House', 'M12 3l9 8h-3v10h-5v-6h-2v6H6V11H3z'],
    ['tag', 'Price tag', 'M2 12V3h9l11 11-9 9zm5-4.5A1.5 1.5 0 1 0 7 4.5a1.5 1.5 0 0 0 0 3z'],
    ['megaphone', 'Megaphone', 'M3 10v4h3l7 5V5L6 10zM15.5 8.5a5 5 0 0 1 0 7l-1.4-1.4a3 3 0 0 0 0-4.2zM18.4 5.6a9 9 0 0 1 0 12.8L17 17a7 7 0 0 0 0-9.9z'],
    ['trophy', 'Trophy', 'M7 3h10v2h4v3a5 5 0 0 1-4.6 5 5 5 0 0 1-3.4 2.7V18h3v3H8v-3h3v-2.3A5 5 0 0 1 7.6 13 5 5 0 0 1 3 8V5h4zM5 7v1a3 3 0 0 0 2 2.8V7zm14 0h-2v3.8A3 3 0 0 0 19 8z'],
    ['crown', 'Crown', 'M2 7l5 5 5-8 5 8 5-5-2 12H4zM4 20h16v2H4z'],
    ['gift', 'Gift', 'M3 8h8v4H3zM13 8h8v4h-8zM4 13h7v8H4zM13 13h7v8h-7zM12 8C10 4 6 3.5 6 6s3 2 6 2zM12 8c2-4 6-4.5 6-2s-3 2-6 2z'],
    ['cake', 'Cake', 'M11 2.5c.6-.8 1.4-.8 2 0 .5.8.2 2-1 2.5-1.2-.5-1.5-1.7-1-2.5zM11 6h2v3h-2zM4 10h16v4.5c-1.3 0-2-.8-2.7-.8s-1.3.8-2.6.8-2-.8-2.7-.8-1.4.8-2.7.8-2-.8-2.6-.8S5.3 14.5 4 14.5zM4 16c1.3 0 2-.8 2.7-.8s1.3.8 2.6.8 2-.8 2.7-.8 1.4.8 2.7.8 2-.8 2.6-.8.9.8 2.7.8V21H4z'],
    ['cap', 'Grad cap', 'M12 3L1 9l11 6 9-4.9V17h2V9zM5 13.2V17c0 1.7 3.1 3 7 3s7-1.3 7-3v-3.8l-7 3.8z'],
    ['balloon', 'Balloon', 'M12 2a6 6 0 0 1 6 6.5c0 4-3.5 7.5-6 7.5s-6-3.5-6-7.5A6 6 0 0 1 12 2zM10.5 16h3l1 2h-5z'],
    ['music', 'Music', 'M9 3h11v4h-9v10.5A3.5 3.5 0 1 1 9 14.3z'],
    ['sun', 'Sun', 'M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zM11 1h2v3h-2zM11 20h2v3h-2zM1 11h3v2H1zM20 11h3v2h-3zM4.2 5.6l1.4-1.4 2.1 2.1-1.4 1.4zM16.3 17.7l1.4-1.4 2.1 2.1-1.4 1.4zM4.2 18.4l2.1-2.1 1.4 1.4-2.1 2.1zM16.3 6.3l2.1-2.1 1.4 1.4-2.1 2.1z'],
    ['bubble', 'Speech', 'M4 3h16a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H9l-5 4v-4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z'],
    ['thumb', 'Thumbs up', 'M2 10h4v11H2zM8 21V10l5-8c1.6 0 2.6 1.3 2.2 2.8L14.3 9H20a2 2 0 0 1 2 2.3l-1.4 8A2 2 0 0 1 18.6 21z'],
    ['paw', 'Paw', 'M12 12c3 0 6 3.5 6 6.3 0 2-1.6 2.7-3 2.7-1.2 0-2-.8-3-.8s-1.8.8-3 .8c-1.4 0-3-.7-3-2.7C6 15.5 9 12 12 12zM5 7.5a2 2.5 0 1 1 0 5 2 2.5 0 0 1 0-5zM19 7.5a2 2.5 0 1 1 0 5 2 2.5 0 0 1 0-5zM9 3a2 2.5 0 1 1 0 5 2 2.5 0 0 1 0-5zM15 3a2 2.5 0 1 1 0 5 2 2.5 0 0 1 0-5z']
  ];

  var SWATCHES = ['#000000', '#ffffff', '#101820', '#3b5060', '#9aa5b1', '#e11d2e',
    '#fc7321', '#f5b700', '#ffd84d', '#1f9d55', '#0b6e4f', '#1d4ed8',
    '#0ea5e9', '#7c3aed', '#db2777', '#8b5a2b'];

  var ICON = {
    undo: '<svg viewBox="0 0 24 24"><path d="M9 14L4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/></svg>',
    redo: '<svg viewBox="0 0 24 24"><path d="M15 14l5-5-5-5"/><path d="M20 9H9.5a5.5 5.5 0 0 0 0 11H13"/></svg>',
    text: '<svg viewBox="0 0 24 24"><path d="M5 6V4h14v2M12 4v16M9 20h6"/></svg>',
    shapes: '<svg viewBox="0 0 24 24"><rect x="3" y="3" width="9" height="9" rx="1.5"/><circle cx="16.5" cy="16.5" r="4.5"/></svg>',
    image: '<svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="2"/><path d="M21 16l-5-5-9 9"/></svg>',
    bg: '<svg viewBox="0 0 24 24"><path d="M12 3a9 9 0 1 0 0 18c1.1 0 1.6-.8 1.6-1.6 0-.5-.2-.8-.4-1.1-.3-.3-.4-.6-.4-1.1 0-.9.7-1.6 1.6-1.6h1.9A4.7 4.7 0 0 0 21 11c0-4.4-4-8-9-8z"/><circle cx="7.5" cy="11" r="1"/><circle cx="10.5" cy="7" r="1"/><circle cx="15.5" cy="7.5" r="1"/></svg>',
    design: '<svg viewBox="0 0 24 24"><path d="M4 20l4-1 11-11-3-3L5 16z"/><path d="M14 6l3 3"/></svg>',
    copy: '<svg viewBox="0 0 24 24"><rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"/></svg>',
    trash: '<svg viewBox="0 0 24 24"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>',
    close: '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  };

  // Phones and small tablets get the canvas-first layout with bottom sheets.
  function isPhoneLayout() { return window.matchMedia('(max-width: 960px)').matches; }
  function isTouch() { return window.matchMedia('(pointer: coarse)').matches; }

  /* ---------------- loading ---------------- */
  var fabricPromise = null;
  function ensureFabric() {
    if (window.fabric) { installTextFit(window.fabric); return Promise.resolve(window.fabric); }
    if (fabricPromise) return fabricPromise;
    fabricPromise = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = FABRIC_SRC;
      s.async = true;
      s.onload = function () {
        if (!window.fabric) return reject(new Error('Designer library failed to start'));
        installTextFit(window.fabric);
        resolve(window.fabric);
      };
      s.onerror = function () { fabricPromise = null; reject(new Error('Designer library failed to load')); };
      document.head.appendChild(s);
    });
    return fabricPromise;
  }

  /* Fabric sizes every text box for generic accents and descenders (≈1.13× the font size,
     with the words sitting high). On all-caps banner fonts that reads as an off-center box.
     Size each box from the ink the words actually use, with even padding top and bottom.
     Patched on the prototype so the print render (bb-print-file.js) lays text out identically. */
  var textFitInstalled = false;
  function installTextFit(fabric) {
    if (textFitInstalled || !fabric.IText) return;
    textFitInstalled = true;
    var measure = document.createElement('canvas').getContext('2d');
    var base = fabric.IText.prototype.initDimensions;
    fabric.IText.prototype.initDimensions = function () {
      fitTextToInk(this, measure);
      return base.apply(this, arguments);
    };
  }

  function fitTextToInk(o, measure) {
    var fs = o.fontSize || 40;
    measure.font = (o.fontStyle || 'normal') + ' ' + (o.fontWeight || 'normal') + ' ' + fs + 'px "' + o.fontFamily + '"';
    var ascent = 0, descent = 0;
    String(o.text || '').split('\n').forEach(function (line) {
      if (!line.trim()) return;
      var m = measure.measureText(line);
      ascent = Math.max(ascent, m.actualBoundingBoxAscent || 0);
      descent = Math.max(descent, m.actualBoundingBoxDescent || 0);
    });
    if (!(ascent > 0)) { delete o._fontSizeMult; delete o._fontSizeFraction; return; }  // empty text: library defaults
    var pad = fs * 0.08 + (o.strokeWidth || 0) / 2;
    var mult = (ascent + descent + 2 * pad) / fs;
    o._fontSizeMult = mult;                                  // box height per line
    o._fontSizeFraction = (descent + pad) / (fs * mult);     // where the baseline sits in it
  }

  function ensureFontCss() {
    if (document.querySelector('link[data-bbd-fonts]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = FONT_CSS;
    l.setAttribute('data-bbd-fonts', '1');
    document.head.appendChild(l);
  }

  function withTimeout(p, ms) {
    return Promise.race([p, new Promise(function (r) { setTimeout(r, ms); })]);
  }

  function loadFont(family, weight, style) {
    ensureFontCss();
    if (!document.fonts || !family) return Promise.resolve();
    return withTimeout(document.fonts.load((style || 'normal') + ' ' + (weight || 400) + ' 40px "' + family + '"').catch(function () {}), 5000);
  }

  function collectFonts(objects, out) {
    (objects || []).forEach(function (o) {
      if (o.fontFamily) out.push(loadFont(o.fontFamily, o.fontWeight, o.fontStyle));
      if (o.objects) collectFonts(o.objects, out);
    });
    return out;
  }
  function ensureFontsFor(json) { return Promise.all(collectFonts(json && json.objects, [])); }

  /* ---------------- offscreen render (used for preview + print) ---------------- */
  async function render(design, outW, outH) {
    var fabric = await ensureFabric();
    await ensureFontsFor(design.json);
    var lw = design.widthIn * UPI, lh = design.heightIn * UPI;
    var sc = new fabric.StaticCanvas(null, { width: lw, height: lh, enableRetinaScaling: false, renderOnAddRemove: false });
    await new Promise(function (r) { sc.loadFromJSON(design.json, r); });
    // Object caches are bitmaps at screen size; drop them so everything renders at print scale.
    sc.getObjects().forEach(function (o) { o.objectCaching = false; });
    sc.renderAll();
    var out = sc.toCanvasElement(outW / lw);
    sc.dispose();
    if (outH && Math.abs(out.height - outH) > 2) {
      var fixed = document.createElement('canvas');
      fixed.width = outW; fixed.height = outH;
      fixed.getContext('2d').drawImage(out, 0, 0, outW, outH);
      return fixed;
    }
    return out;
  }

  /* ---------------- editor ---------------- */
  var ui = null;          // DOM refs
  var canvas = null;      // fabric.Canvas
  var lw = 0, lh = 0;     // layout size (units)
  var widthIn = 0, heightIn = 0;
  var history = [], histIdx = -1, restoring = false, dirty = false;
  var guides = { v: false, h: false };
  var saveTimer = null;
  var lastFocus = null;

  function el(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstElementChild;
  }

  // Sizes show in feet or inches, whichever the customer picked (remembered on this device).
  var sizeUnit = 'ft';
  try { if (localStorage.getItem('bbdSizeUnit') === 'in') sizeUnit = 'in'; } catch (e) {}

  function fmtSize(inches, unit) {
    if ((unit || sizeUnit) === 'in') return (Math.round(inches * 10) / 10) + '"';
    if (inches % 6 === 0) return (inches / 12) + ' ft';   // whole and half feet read as feet
    return (Math.round(inches * 10) / 10) + '"';
  }

  function buildUI() {
    var logo = logoUrl();
    var root = el(
      '<div class="bbd" role="dialog" aria-modal="true" aria-labelledby="bbdTitle" hidden>' +
        '<div class="bbd-top">' +
          '<button type="button" class="bbd-icon-btn bbd-m-only bbd-close" data-a="cancel" aria-label="Close designer">' + ICON.close + '</button>' +
          '<div class="bbd-brand">' +
            (logo ? '<a class="bbd-home" href="/" title="Back to the homepage"><img class="bbd-logo" src="' + logo + '" alt="Blazing Banner home" width="140" height="62"></a>' : '') +
            '<span class="bbd-brand-div" aria-hidden="true"></span>' +
            '<h2 id="bbdTitle">Banner <em>Designer</em></h2>' +
          '</div>' +
          '<div class="bbd-now" aria-live="polite"><span class="bbd-now-kick bbd-d-only">Designing</span><b data-r="nowName">Banner 1</b><span class="bbd-size" data-r="size"></span></div>' +
          '<div class="bbd-top-actions">' +
            '<span class="bbd-edge-warn" data-r="edgeWarn" hidden>Some text is close to the edge</span>' +
            '<button type="button" class="bbd-help-btn" data-a="help" aria-label="Need help? Open the quick guide"><span class="bbd-help-q" aria-hidden="true">?</span><span class="bbd-d-only">Need help?</span></button>' +
            '<button type="button" class="bbd-icon-btn" data-a="undo" aria-label="Undo" title="Undo (Ctrl+Z)">' + ICON.undo + '</button>' +
            '<button type="button" class="bbd-icon-btn" data-a="redo" aria-label="Redo" title="Redo (Ctrl+Y)">' + ICON.redo + '</button>' +
            '<button type="button" class="bbd-btn bbd-btn-ghost bbd-d-only" data-a="cancel">Cancel</button>' +
            '<button type="button" class="bbd-btn bbd-btn-primary" data-a="done"><span class="bbd-d-only">Use this design</span><span class="bbd-m-only">Use design</span></button>' +
          '</div>' +
        '</div>' +
        '<div class="bbd-body">' +
          '<aside class="bbd-banners" aria-label="Banners in your order">' +
            '<div class="bbd-banners-head">Your banners</div>' +
            '<div class="bbd-strip" data-r="strip" role="list"></div>' +
          '</aside>' +
          '<nav class="bbd-rail" role="tablist" aria-label="Design tools">' +
            tabBtn('text', 'Text', ICON.text) + tabBtn('shapes', 'Shapes', ICON.shapes) +
            tabBtn('image', 'Images', ICON.image) + tabBtn('background', 'Banner', ICON.bg) +
          '</nav>' +
          '<div class="bbd-drawer" data-r="drawer">' +
            '<section class="bbd-pane" data-pane="text">' +
              '<h3>Add text</h3>' +
              '<button type="button" class="bbd-add-text bbd-add-h1" data-a="add-headline">Add a headline</button>' +
              '<button type="button" class="bbd-add-text bbd-add-h2" data-a="add-subheading">Add a subheading</button>' +
              '<button type="button" class="bbd-add-text bbd-add-body" data-a="add-body">Add body text</button>' +
              '<div class="bbd-lines-head"><h3>Your text</h3><span>Type here to change each line</span></div>' +
              '<div class="bbd-lines" data-r="lines"></div>' +
              '<button type="button" class="bbd-add-line" data-a="add-line">+ Add another line</button>' +
            '</section>' +
            '<section class="bbd-pane" data-pane="shapes" hidden>' +
              '<h3>Shapes</h3>' +
              '<div class="bbd-shape-grid">' +
                shapeBtn('rect', 'Rectangle', '<rect x="4" y="6" width="16" height="12"/>') +
                shapeBtn('rounded', 'Rounded box', '<rect x="4" y="6" width="16" height="12" rx="4"/>') +
                shapeBtn('circle', 'Circle', '<circle cx="12" cy="12" r="8"/>') +
                shapeBtn('triangle', 'Triangle', '<path d="M12 4l9 16H3z"/>') +
                shapeBtn('star', 'Star', '<path d="M12 3l2.7 5.8 6.3.7-4.7 4.3 1.3 6.2L12 16.9 6.4 20l1.3-6.2L3 9.5l6.3-.7z"/>') +
                shapeBtn('line', 'Line', '<path d="M3 12h18" stroke-width="3"/>') +
                shapeBtn('burst', 'Burst', '<path d="M12 2l1.8 3.1 3.4-1.1.4 3.6 3.5.9-1.6 3.2 2.4 2.7-3.3 1.4.1 3.6-3.5-.6L13.4 22 12 19l-1.4 3-1.8-3.1-3.5.6.1-3.6L2.1 17.5l2.4-2.7L2.9 11.6l3.5-.9.4-3.6 3.4 1.1z"/>') +
                shapeBtn('banner', 'Ribbon', '<path d="M2 8h4V6h12v2h4l-2 4 2 4h-4v2H6v-2H2l2-4z"/>') +
                shapeBtn('pill', 'Pill', '<rect x="2" y="8" width="20" height="8" rx="4"/>') +
              '</div>' +
              '<p class="bbd-tip">Use a rectangle as a color band behind text, then send it back with the layer buttons.</p>' +
            '</section>' +
            '<section class="bbd-pane" data-pane="image" hidden>' +
              '<h3>Your logo or photo</h3>' +
              '<button type="button" class="bbd-upload" data-a="add-image">' + ICON.image + '<span><strong>Upload a logo or photo</strong><small>PNG, JPG or WebP · or drop it on the banner</small></span></button>' +
              '<input type="file" accept="image/png,image/jpeg,image/webp" data-r="imageInput" hidden>' +
              '<p class="bbd-tip">Logos with a see-through (PNG) background look best. We\'ll tell you how sharp each image will print.</p>' +
              ELEMENT_GROUPS.map(function (grp) {
                return '<h3 class="bbd-h-gap">' + grp.label + '</h3><div class="bbd-elements">' + grp.items.map(function (id) {
                  return '<button type="button" class="bbd-element" data-a="add-element" data-el="' + id + '" title="' + elementLabel(id) + '" aria-label="Add ' + elementLabel(id) + '">' +
                    '<img alt="" loading="lazy" decoding="async" data-src="' + elementUrl(id) + '"></button>';
                }).join('') + '</div>';
              }).join('') +
              '<h3 class="bbd-h-gap">' + (ELEMENT_GROUPS.length ? 'Simple icons' : 'Graphics') + ' <span class="bbd-h-note">pick any color</span></h3>' +
              '<div class="bbd-graphics">' + GRAPHICS.map(function (g) {
                return '<button type="button" class="bbd-graphic" data-a="add-graphic" data-g="' + g[0] + '" title="' + g[1] + '" aria-label="Add ' + g[1] + '"><svg viewBox="0 0 24 24"><path d="' + g[2] + '" fill-rule="evenodd"/></svg></button>';
              }).join('') + '</div>' +
              '<p class="bbd-tip">Tap a graphic to add it, then change its color on the right.</p>' +
            '</section>' +
            // Banner settings as fold-out rows: each row shows its current value, color opens first.
            '<section class="bbd-pane" data-pane="background" hidden>' +
              '<details class="bbd-acc" open>' +
                '<summary><span class="bbd-acc-name">Background color</span><span class="bbd-acc-val" data-r="accBg"></span></summary>' +
                '<div class="bbd-acc-body"><div data-r="bgSwatches"></div><p class="bbd-tip">Dark backgrounds with bright text stand out from far away.</p></div>' +
              '</details>' +
              '<details class="bbd-acc">' +
                '<summary><span class="bbd-acc-name">Banner size</span><span class="bbd-acc-val" data-r="accSize"></span></summary>' +
                '<div class="bbd-acc-body" data-r="sizeBox"></div>' +
              '</details>' +
              '<details class="bbd-acc">' +
                '<summary><span class="bbd-acc-name">Grommets</span><span class="bbd-acc-val" data-r="accGrom"></span></summary>' +
                '<div class="bbd-acc-body" data-r="gromBox"></div>' +
              '</details>' +
            '</section>' +
          '</div>' +
          '<div class="bbd-stage" data-r="stage">' +
            '<div class="bbd-board" data-r="board"><canvas data-r="canvas"></canvas></div>' +
            '<div class="bbd-quick" data-r="quick" hidden></div>' +
            '<p class="bbd-stage-hint"><i></i><span class="bbd-d-only">What you see is what prints. Keep words inside the dashed line and off the shaded grommet circles.</span><span class="bbd-m-only">Keep words inside the dashed line</span></p>' +
            // Phones: a simple start panel in the space the tool sheets use, until something is picked.
            '<div class="bbd-start" data-r="start" aria-label="Quick start">' +
              '<p class="bbd-start-title">Make it yours in 3 quick steps</p>' +
              '<ol class="bbd-start-steps">' +
                '<li><span class="bbd-start-n" aria-hidden="true">1</span><div class="bbd-start-body"><label class="bbd-start-label" for="bbdStartText">Type your words</label>' +
                  '<textarea class="bbd-start-text" id="bbdStartText" data-start-text rows="1" placeholder="Your business name or message"></textarea>' +
                  '<div class="bbd-start-style">' +
                    '<button type="button" class="bbd-start-font" data-a="start-font"><span class="bbd-start-font-k">Font</span><b data-r="startFont">Anton</b><span aria-hidden="true">▾</span></button>' +
                    '<div class="bbd-start-colors" data-r="startTextColors" role="group" aria-label="Text color"></div>' +
                  '</div></div></li>' +
                '<li><span class="bbd-start-n" aria-hidden="true">2</span><div class="bbd-start-body"><span class="bbd-start-label">Pick a banner background color</span><div class="bbd-start-swatches" data-r="startSwatches"></div></div></li>' +
                '<li><span class="bbd-start-n" aria-hidden="true">3</span><div class="bbd-start-body"><span class="bbd-start-label">Add a logo or photo <small>(optional)</small></span>' +
                  '<button type="button" class="bbd-start-btn" data-a="add-image">' + ICON.image + 'Upload a logo or photo</button></div></li>' +
              '</ol>' +
              '<p class="bbd-start-tip">Tap anything on the banner to move or change it. Done? Tap <b>Use design</b>.</p>' +
            '</div>' +
          '</div>' +
          '<aside class="bbd-inspector" data-r="inspector" aria-label="Selected item settings"></aside>' +
        '</div>' +
        '<div class="bbd-busy" data-r="busy"><span class="bbd-spinner"></span><span data-r="busyText">Loading designer…</span></div>' +
        '<div class="bbd-toast" data-r="toast" role="status" aria-live="polite"></div>' +
      '</div>'
    );
    document.body.appendChild(root);
    var refs = { root: root };
    root.querySelectorAll('[data-r]').forEach(function (n) { refs[n.getAttribute('data-r')] = n; });
    return refs;
  }

  function tabBtn(id, label, icon) {
    return '<button type="button" class="bbd-tab" role="tab" data-tab="' + id + '" aria-selected="' + (id === 'text') + '">' + icon + '<span>' + label + '</span></button>';
  }
  function shapeBtn(kind, label, svg) {
    return '<button type="button" class="bbd-shape" data-a="add-shape" data-shape="' + kind + '" aria-label="Add ' + label + '"><svg viewBox="0 0 24 24">' + svg + '</svg><span>' + label + '</span></button>';
  }

  function swatchRow(target, current) {
    var cur = String(current || '').toLowerCase();
    return '<div class="bbd-swatches">' + SWATCHES.map(function (c) {
      return '<button type="button" class="bbd-swatch' + (c === cur ? ' is-on' : '') + '" style="background:' + c + '" data-swatch="' + target + '" data-color="' + c + '" aria-label="' + c + '"></button>';
    }).join('') +
      '<label class="bbd-swatch bbd-swatch-custom" title="Custom color"><input type="color" data-p="' + target + '" value="' + toHex(current) + '" aria-label="Custom color"></label>' +
      '</div>';
  }

  function toHex(c) {
    if (!c || typeof c !== 'string') return '#000000';
    if (/^#[0-9a-f]{6}$/i.test(c)) return c.toLowerCase();
    try { return '#' + new window.fabric.Color(c).toHex().toLowerCase(); } catch (e) { return '#000000'; }
  }

  /* ---------------- open / close / banners ---------------- */
  var currentSetId = null;

  function sets() { return (window.BBBuilder && window.BBBuilder.getSets && window.BBBuilder.getSets()) || []; }
  function currentSet() { return sets().filter(function (s) { return s.id === currentSetId; })[0] || null; }
  function bannerNumber(set) { return Math.max(0, sets().indexOf(set)) + 1; }

  function isBlank() {
    var bg = String(canvas.backgroundColor || '#ffffff').toLowerCase();
    return !canvas.getObjects().length && (bg === '#ffffff' || bg === 'white');
  }

  async function open() {
    var builder = window.BBBuilder;
    if (!builder) return;
    var size = builder.getBannerSizeInches();
    if (!(size.widthIn >= 1 && size.heightIn >= 1)) { alert('Choose a banner size first.'); return; }

    if (!ui) { ui = buildUI(); bindUI(); }
    lastFocus = document.activeElement;
    ui.root.hidden = false;
    document.documentElement.classList.add('bbd-open');
    // Shopify's theme-preview bar sits over the bottom of the screen; stop above it so the
    // tool bar and settings sheets stay reachable while previewing. (Customers never see it.)
    var bar = document.querySelector('#PBarNextFrameWrapper, #preview-bar-iframe');
    var barTop = bar ? bar.getBoundingClientRect().top : 0;
    var hostBottom = bar && barTop > window.innerHeight / 2 ? Math.round(window.innerHeight - barTop) : 0;
    ui.root.style.setProperty('--bbd-host-bottom', hostBottom + 'px');
    ui.root.style.bottom = hostBottom ? hostBottom + 'px' : '';
    setBusy('Loading designer…');
    ensureFontCss();

    try {
      var fabric = await ensureFabric();
      if (!canvas) initCanvas(fabric);
    } catch (err) {
      setBusy(null);
      toast(err.message || 'Designer failed to load. Check your connection and try again.');
      return;
    }
    await loadActive();
    ui.root.querySelector('[data-a="done"]').focus();
    // First visit: show the quick guide once. It's always one tap away under Need help?
    var seen = false;
    try { seen = localStorage.getItem('bbdHelpSeen') === '1'; } catch (e) {}
    var starting = !!ui.root.querySelector('.bbd-startscreen:not([hidden])');
    if (!seen && !starting) openHelp();   // the start screen already guides a brand-new banner
  }

  // Put the builder's active banner on the artboard: its saved design, or a fresh start.
  async function loadActive() {
    var builder = window.BBBuilder;
    var size = builder.getBannerSizeInches();
    widthIn = size.widthIn; heightIn = size.heightIn;
    lw = widthIn * UPI; lh = heightIn * UPI;

    var set = builder.getActiveSet();
    currentSetId = set ? set.id : null;
    var design = set && set.design;
    restoring = true;
    canvas.discardActiveObject();
    canvas.clear();
    if (design) {
      await ensureFontsFor(design.json);
      await new Promise(function (r) { canvas.loadFromJSON(design.json, r); });
      canvas.getObjects().forEach(styleObject);
      if (design.widthIn !== widthIn || design.heightIn !== heightIn) rescaleLayout(design.widthIn * UPI, design.heightIn * UPI);
    } else if (set && set.dataUrl) {
      // The customer's own upload: bring it in whole, centered, on its matched background color,
      // so they can resize/move it (in proportion) and add text around it. What's on the artboard prints.
      canvas.setBackgroundColor(set.bgColor || set.edgeColor || '#ffffff');
      await importUpload(set);
      if (set.edgeColor && !set.bgColor) setTimeout(function () { toast('We matched the background to your artwork. Change it under Background color.'); }, 400);
    } else {
      // Nothing yet: blank white banner and the "How do you want to start?" screen (no placeholder text).
      canvas.setBackgroundColor('#ffffff');
      await loadFont('Anton');
      showStartScreen = true;
    }
    restoring = false;
    fit();
    history = []; histIdx = -1; pushHistory(); dirty = false;
    setBusy(null);
    selectTab('text');
    ui.root.classList.remove('bbd-sheet-tool');
    if (isPhoneLayout()) ui.root.querySelectorAll('.bbd-tab').forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
    refreshInspector();
    checkEdges();
    renderHeader();
    renderStrip();
    if (showStartScreen) { showStartScreen = false; openStart(); } else closeStart();
  }

  /* ---------------- "How do you want to start?" ----------------
     Shown instead of placeholder text when a banner has no design and no upload. Three simple paths:
     their logo/photo (placed + background matched), just their words (laid out for them), or an example. */
  var showStartScreen = false, startUploadPending = false;
  var START_THEMES = [
    { bg: '#ffffff', main: '#101820', accent: '#e8560a', name: 'Black on white' },
    { bg: '#101820', main: '#ffffff', accent: '#ffc21a', name: 'White on black' },
    { bg: '#e8560a', main: '#ffffff', accent: '#101820', name: 'White on orange' },
    { bg: '#ffc21a', main: '#101820', accent: '#101820', name: 'Black on yellow' },
    { bg: '#1d4ed8', main: '#ffffff', accent: '#ffc21a', name: 'White on blue' },
    { bg: '#b91c1c', main: '#ffffff', accent: '#ffe08a', name: 'White on red' }
  ];
  var START_EXAMPLES = [
    { name: 'Grand Opening', bg: '#e8560a', lines: [['GRAND', 'Anton', 400, '#ffffff', .34], ['OPENING', 'Anton', 400, '#101820', .34], ['This Saturday · 10 AM', 'Montserrat', 700, '#ffffff', .1]] },
    { name: 'Now Hiring', bg: '#101820', lines: [['NOW HIRING', 'Anton', 400, '#ffc21a', .34], ['Apply inside today', 'Montserrat', 700, '#ffffff', .11]] },
    { name: 'Yard Sale', bg: '#ffc21a', lines: [['YARD SALE', 'Anton', 400, '#101820', .38], ['Saturday 8 AM – 2 PM', 'Montserrat', 700, '#101820', .11]] },
    { name: 'Happy Birthday', bg: '#7c3aed', lines: [['HAPPY BIRTHDAY', 'Anton', 400, '#ffffff', .28], ['EMMA!', 'Anton', 400, '#ffc21a', .24]] },
    { name: 'Fresh Tacos', bg: '#fbf6ec', lines: [['FRESH TACOS', 'Anton', 400, '#c2410c', .34], ['3 for $10', 'Montserrat', 800, '#101820', .16]] },
    { name: 'Sale', bg: '#dc2626', lines: [['SALE', 'Anton', 400, '#ffffff', .5], ['Up to 50% off', 'Montserrat', 700, '#ffffff', .12]] }
  ];

  function startIcon(kind) {
    if (kind === 'upload') return '<svg viewBox="0 0 64 48" aria-hidden="true"><rect x="2" y="6" width="60" height="36" rx="4" fill="#fbf6ec" stroke="#10181f" stroke-opacity=".3"/><circle cx="32" cy="24" r="11" fill="#d99a4e" stroke="#6b3a1a" stroke-width="2"/><circle cx="28" cy="21" r="2" fill="#6b3a1a"/><circle cx="35" cy="27" r="1.8" fill="#6b3a1a"/></svg>';
    if (kind === 'words') return '<svg viewBox="0 0 64 48" aria-hidden="true"><rect x="2" y="6" width="60" height="36" rx="4" fill="#101820"/><rect x="12" y="14" width="40" height="9" rx="2" fill="#fff"/><rect x="18" y="27" width="28" height="6" rx="2" fill="#ffc21a"/><rect x="22" y="36" width="20" height="3" rx="1.5" fill="#fff" fill-opacity=".7"/></svg>';
    return '<svg viewBox="0 0 64 48" aria-hidden="true"><rect x="2" y="6" width="28" height="17" rx="2" fill="#e8560a"/><rect x="34" y="6" width="28" height="17" rx="2" fill="#ffc21a"/><rect x="2" y="25" width="28" height="17" rx="2" fill="#101820"/><rect x="34" y="25" width="28" height="17" rx="2" fill="#dc2626"/></svg>';
  }

  function startEl() {
    var box = ui.root.querySelector('.bbd-startscreen');
    if (box) return box;
    box = el('<div class="bbd-startscreen" role="dialog" aria-modal="true" aria-labelledby="bbdStartTitle" hidden><div class="bbd-ss-card">' +
      '<div class="bbd-ss-page" data-ss="home">' +
        '<h3 id="bbdStartTitle">How do you want to start?</h3><p class="bbd-ss-sub">Pick one. You can change anything after.</p>' +
        '<div class="bbd-ss-choices">' +
          [['upload', 'Use my logo or photo', 'We place it and match the background'],
           ['words', 'Just type my words', 'We lay them out big and easy to read']
           // ['example', 'Start from an example', 'Pick one, then change the words']  (back once real templates exist)
          ].map(function (c) {
            return '<button type="button" class="bbd-ss-choice" data-start="' + c[0] + '"><span class="bbd-ss-ico">' + startIcon(c[0]) + '</span><span class="bbd-ss-txt"><b>' + c[1] + '</b><small>' + c[2] + '</small></span></button>';
          }).join('') +
        '</div><button type="button" class="bbd-ss-blank" data-start="blank">Start with a blank banner</button>' +
      '</div>' +
      '<div class="bbd-ss-page" data-ss="words" hidden>' +
        '<button type="button" class="bbd-ss-back" data-start="home">← Back</button>' +
        '<h3>What should your banner say?</h3><p class="bbd-ss-sub">One line per row. The first line is the biggest.</p>' +
        '<textarea class="bbd-ss-text" id="bbdSsText" rows="4" placeholder="GRAND OPENING&#10;Saturday 10 AM&#10;(316) 555-0123"></textarea>' +
        '<div class="bbd-ss-label">Colors</div><div class="bbd-ss-themes" role="group" aria-label="Colors">' +
          START_THEMES.map(function (t, i) {
            return '<button type="button" class="bbd-ss-theme' + (i === 0 ? ' on' : '') + '" data-theme="' + i + '" aria-label="' + t.name + '" style="background:' + t.bg + ';color:' + t.main + '"><b>Aa</b><i style="background:' + t.accent + '"></i></button>';
          }).join('') + '</div>' +
        '<button type="button" class="bbd-btn bbd-btn-primary bbd-ss-go" data-start="make-words">Make my banner</button>' +
      '</div>' +
      '<div class="bbd-ss-page" data-ss="example" hidden>' +
        '<button type="button" class="bbd-ss-back" data-start="home">← Back</button>' +
        '<h3>Pick an example</h3><p class="bbd-ss-sub">Then tap the words on the banner to change them.</p>' +
        '<div class="bbd-ss-examples">' + START_EXAMPLES.map(function (x, i) {
          return '<button type="button" class="bbd-ss-example" data-example="' + i + '"><span class="bbd-ss-mini" style="background:' + x.bg + '">' +
            x.lines.map(function (l) { return '<span style="color:' + l[3] + ';font-family:' + (l[1] === 'Anton' ? 'Anton,Impact,Arial' : 'Montserrat,Arial') + ';font-weight:' + l[2] + ';font-size:' + Math.round(l[4] * 46) + 'px">' + l[0] + '</span>'; }).join('') +
            '</span><b>' + x.name + '</b></button>';
        }).join('') + '</div>' +
      '</div>' +
    '</div></div>');
    ui.root.appendChild(box);
    var theme = 0;
    box.addEventListener('click', function (e) {
      var t = e.target.closest('[data-theme]');
      if (t) { theme = +t.getAttribute('data-theme'); box.querySelectorAll('.bbd-ss-theme').forEach(function (b) { b.classList.toggle('on', b === t); }); return; }
      var ex = e.target.closest('[data-example]');
      if (ex) { var x = START_EXAMPLES[+ex.getAttribute('data-example')]; buildFromLines(x.bg, x.lines); closeStart(); return; }
      var a = e.target.closest('[data-start]');
      if (!a) return;
      var k = a.getAttribute('data-start');
      if (k === 'home' || k === 'words' || k === 'example') {
        box.querySelectorAll('.bbd-ss-page').forEach(function (p) { p.hidden = p.getAttribute('data-ss') !== k; });
        if (k === 'words') setTimeout(function () { box.querySelector('#bbdSsText').focus(); }, 30);
        return;
      }
      if (k === 'blank') { closeStart(); return; }
      if (k === 'upload') { startUploadPending = true; ui.imageInput.click(); return; }
      if (k === 'make-words') {
        var lines = box.querySelector('#bbdSsText').value.split(/\n/).map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 5);
        if (!lines.length) { box.querySelector('#bbdSsText').focus(); toast('Type what your banner should say first.'); return; }
        var th = START_THEMES[theme];
        buildFromLines(th.bg, lines.map(function (s, i) {
          return i === 0 ? [s, 'Anton', 400, th.main, .36] : [s, i === 1 ? 'Anton' : 'Montserrat', i === 1 ? 400 : 700, i === 1 ? th.accent : th.main, i === 1 ? .2 : .11];
        }));
        closeStart();
      }
    });
    return box;
  }

  function openStart() {
    var box = startEl();
    box.querySelectorAll('.bbd-ss-page').forEach(function (p) { p.hidden = p.getAttribute('data-ss') !== 'home'; });
    box.hidden = false;
    var first = box.querySelector('.bbd-ss-choice');
    if (first) first.focus();
  }
  function closeStart() {
    var box = ui && ui.root.querySelector('.bbd-startscreen');
    if (box) box.hidden = true;
  }

  // Lay out lines of text big, centered, each inside the safe area; [text, font, weight, color, relative size].
  async function buildFromLines(bg, lines) {
    var fabric = window.fabric;
    await Promise.all(lines.map(function (l) { return loadFont(l[1], l[2]); }));
    lines.forEach(function (l) { try { fabric.util.clearFabricFontCache(l[1]); } catch (e) {} });
    canvas.getObjects().slice().forEach(function (o) { canvas.remove(o); });
    canvas.setBackgroundColor(bg);
    var safe = SAFE_IN * UPI, availW = (lw - 2 * safe) * 0.92, availH = (lh - 2 * safe) * 0.86;
    var objs = lines.map(function (l) {
      var t = new fabric.IText(l[0], { fontFamily: l[1], fontWeight: l[2], fill: l[3], fontSize: Math.max(10, Math.round(lh * l[4])),
        textAlign: 'center', originX: 'center', originY: 'center', left: lw / 2, top: lh / 2, strokeWidth: 0, strokeUniform: true, paintFirst: 'stroke' });
      if (t.width > availW) t.set('fontSize', Math.floor(t.fontSize * availW / t.width));
      styleObject(t);
      return t;
    });
    var gap = function (o) { return o.fontSize * 0.12; };
    var total = objs.reduce(function (n, o) { return n + o.height + gap(o); }, 0);
    if (total > availH) {
      var k = availH / total;
      objs.forEach(function (o) { o.set('fontSize', Math.max(8, Math.floor(o.fontSize * k))); o.initDimensions(); });
      total = objs.reduce(function (n, o) { return n + o.height + gap(o); }, 0);
    }
    var y = (lh - total) / 2;
    objs.forEach(function (o) { o.set({ top: y + o.height / 2 }); y += o.height + gap(o); o.setCoords(); canvas.add(o); });
    canvas.discardActiveObject();
    canvas.requestRenderAll();
    dirty = true; pushHistory(); refreshInspector(); checkEdges(); scheduleStrip();
    toast('Tap any words on the banner to change them');
  }

  /* ---------- match background + help guide ---------- */
  // Median color of an image's outer ring, or null if the edge isn't one solid color.
  function edgeColorOf(el) {
    try {
      var N = 96, c = document.createElement('canvas');
      c.width = N; c.height = N;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(el, 0, 0, N, N);
      var d = x.getImageData(0, 0, N, N).data, px = [];
      for (var yy = 0; yy < N; yy++) for (var xx = 0; xx < N; xx++) {
        if (xx > 1 && xx < N - 2 && yy > 1 && yy < N - 2) continue;
        var i = (yy * N + xx) * 4;
        if (d[i + 3] < 200) return null;
        px.push([d[i], d[i + 1], d[i + 2]]);
      }
      var med = [0, 1, 2].map(function (k) { return px.map(function (p) { return p[k]; }).sort(function (a, b) { return a - b; })[px.length >> 1]; });
      var close = px.filter(function (p) { return Math.abs(p[0] - med[0]) + Math.abs(p[1] - med[1]) + Math.abs(p[2] - med[2]) < 36; }).length;
      void close;                                                      // busy edges still get the median color
      if (med.every(function (v) { return v > 246; })) return null;   // white: nothing to match
      return '#' + med.map(function (v) { return v.toString(16).padStart(2, '0'); }).join('');
    } catch (e) { return null; }
  }

  function artworkColor() { var s = currentSet(); return (s && s.edgeColor) || null; }

  // One-tap control shown above the background swatches when the upload has a solid edge color.
  function matchBgControl() {
    var c = artworkColor();
    if (!c) return '';
    var on = canvas && String(canvas.backgroundColor).toLowerCase() === c.toLowerCase();
    return '<button type="button" class="bbd-matchbg' + (on ? ' is-on' : '') + '" data-a="match-bg" aria-pressed="' + on + '">' +
      '<i style="background:' + c + '"></i><span>' + (on ? 'Background matches your artwork ✓' : 'Match my artwork’s background') + '</span></button>';
  }

  function matchBackground() {
    var c = artworkColor();
    if (!c) return;
    applyProp('background', c);
    refreshInspector();
    toast('Background matched to your artwork');
  }

  var HELP_STEPS = [
    ['Move it and size it', '<b>Drag</b> your artwork to move it. <b>Drag a corner</b> to make it bigger or smaller. It keeps its shape.'],
    ['Center it', 'Tap your artwork, then tap <b>↔</b> (side to side), <b>↕</b> (top to bottom) or <b>⊕</b> (dead center) in the little bar above it.'],
    ['Fill the empty space', 'Tap <b>Match my artwork’s background</b> to fill the sides with one solid color from your artwork. Or pick any color you like.'],
    ['Make it fit exactly', 'Tap your artwork, then <b>Fit</b>: show the whole image, fill the banner, <b>stretch to fit</b>, or turn on <b>Free transform</b> to stretch it yourself.'],
    ['Add words', 'Tap <b>Add a headline</b>, then type. Use <b>A−</b> and <b>A+</b> for size, and tap a color dot to change the color.'],
    ['Stay off the edges', 'Keep words inside the <b>dashed line</b> and off the <b>shaded circles</b>. That’s where the grommet holes go.'],
    ['Check it and finish', '<b>What you see is exactly what prints.</b> When it looks right, tap <b>Use this design</b>.']
  ];

  // A small drawing for each step, so the guide can be followed by looking.
  var HELP_PICS = (function () {
    var O = '#e8560a', INK = '#10181f', G = '#17915a', CREAM = '#fbf6ec';
    function svg(inner) { return '<svg viewBox="0 0 200 110" aria-hidden="true">' + inner + '</svg>'; }
    function board(x, y, w, h, fill) {
      return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="3" fill="' + (fill || '#fff') + '" stroke="' + INK + '" stroke-opacity=".25"/>';
    }
    function cookie(cx, cy, r) {
      return '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="#d99a4e" stroke="#6b3a1a" stroke-width="2"/>' +
        '<circle cx="' + (cx - r * .35) + '" cy="' + (cy - r * .2) + '" r="' + r * .14 + '" fill="#6b3a1a"/><circle cx="' + (cx + r * .3) + '" cy="' + (cy + r * .25) + '" r="' + r * .12 + '" fill="#6b3a1a"/>';
    }
    function handles(x, y, w, h) {
      return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" fill="none" stroke="' + O + '" stroke-width="1.5" stroke-dasharray="3 2"/>' +
        [[x, y], [x + w, y], [x, y + h], [x + w, y + h]].map(function (p) { return '<rect x="' + (p[0] - 3.5) + '" y="' + (p[1] - 3.5) + '" width="7" height="7" fill="#fff" stroke="' + O + '" stroke-width="2"/>'; }).join('');
    }
    function arrow(x1, y1, x2, y2) {
      return '<path d="M' + x1 + ' ' + y1 + 'L' + x2 + ' ' + y2 + '" stroke="' + O + '" stroke-width="3" stroke-linecap="round" marker-end="url(#bbdArr)"/>';
    }
    var defs = '<defs><marker id="bbdArr" viewBox="0 0 10 10" refX="6" refY="5" markerWidth="4" markerHeight="4" orient="auto"><path d="M0 0L10 5L0 10z" fill="' + O + '"/></marker></defs>';
    function words(x, y, a, b) {
      return '<text x="' + x + '" y="' + y + '" text-anchor="middle" font-family="Arial Black,Arial" font-weight="900" font-size="12" fill="' + INK + '">' + a + '</text>' +
        (b ? '<text x="' + x + '" y="' + (y + 14) + '" text-anchor="middle" font-family="Arial Black,Arial" font-weight="900" font-size="12" fill="' + O + '">' + b + '</text>' : '');
    }
    return [
      svg(defs + board(20, 15, 160, 80, CREAM) + cookie(88, 55, 20) + handles(66, 33, 44, 44) + arrow(116, 83, 134, 98) + arrow(60, 55, 38, 55)),
      svg(board(30, 28, 140, 72, CREAM) + cookie(100, 64, 18) + '<line x1="100" y1="28" x2="100" y2="100" stroke="' + O + '" stroke-width="1.5" stroke-dasharray="3 3"/><line x1="30" y1="64" x2="170" y2="64" stroke="' + O + '" stroke-width="1.5" stroke-dasharray="3 3"/>' +
        '<rect x="54" y="4" width="92" height="20" rx="6" fill="#fff" stroke="' + INK + '" stroke-width="1.5"/>' + ['↔', '↕', '⊕'].map(function (t, i) { return '<text x="' + (72 + i * 28) + '" y="19" text-anchor="middle" font-family="Arial" font-weight="700" font-size="14" fill="' + (i === 2 ? O : INK) + '">' + t + '</text>'; }).join('')),
      svg(board(10, 20, 84, 50, '#fff') + '<rect x="30" y="20" width="44" height="50" fill="' + CREAM + '"/>' + cookie(52, 45, 14) +
        '<path d="M100 45h14m-5-5 5 5-5 5" stroke="' + O + '" stroke-width="3" fill="none" stroke-linecap="round"/>' +
        board(120, 20, 72, 50, CREAM) + cookie(156, 45, 14) + '<rect x="120" y="80" width="72" height="18" rx="9" fill="' + O + '"/><text x="156" y="93" text-anchor="middle" font-family="Arial" font-weight="800" font-size="9" fill="#fff">Match</text>'),
      svg(board(8, 22, 58, 40, '#fff') + '<rect x="21" y="22" width="32" height="40" fill="' + CREAM + '"/>' + cookie(37, 42, 12) +
        board(72, 22, 58, 40, CREAM) + '<clipPath id="bbdClF"><rect x="72" y="22" width="58" height="40"/></clipPath><g clip-path="url(#bbdClF)">' + cookie(101, 42, 24) + '</g>' +
        board(136, 22, 58, 40, CREAM) + '<ellipse cx="165" cy="42" rx="22" ry="12" fill="#d99a4e" stroke="#6b3a1a" stroke-width="2"/>' +
        '<text x="37" y="78" text-anchor="middle" font-family="Arial" font-size="10" fill="' + INK + '">Whole</text><text x="101" y="78" text-anchor="middle" font-family="Arial" font-size="10" fill="' + INK + '">Fill</text><text x="165" y="78" text-anchor="middle" font-family="Arial" font-size="10" fill="' + INK + '">Stretch</text>'),
      svg(board(20, 12, 160, 64, CREAM) + cookie(55, 44, 16) + words(128, 40, 'FRESH', 'COOKIES') +
        '<rect x="44" y="84" width="112" height="22" rx="8" fill="#fff" stroke="' + INK + '" stroke-width="1.5"/><text x="64" y="99" text-anchor="middle" font-family="Arial" font-weight="800" font-size="11" fill="' + INK + '">A−</text><text x="88" y="99" text-anchor="middle" font-family="Arial" font-weight="800" font-size="11" fill="' + INK + '">A+</text>' +
        ['#e8560a', '#10181f', '#17915a'].map(function (c, i) { return '<circle cx="' + (112 + i * 14) + '" cy="95" r="5" fill="' + c + '" stroke="#fff" stroke-width="1.5"/>'; }).join('')),
      svg(board(20, 12, 160, 86, CREAM) + '<rect x="30" y="22" width="140" height="66" fill="none" stroke="' + INK + '" stroke-opacity=".5" stroke-dasharray="4 3"/>' +
        [[32, 24], [100, 24], [168, 24], [32, 86], [100, 86], [168, 86]].map(function (p) { return '<circle cx="' + p[0] + '" cy="' + p[1] + '" r="8" fill="' + O + '" fill-opacity=".18" stroke="' + O + '" stroke-dasharray="2 2"/><circle cx="' + p[0] + '" cy="' + p[1] + '" r="3" fill="#8a939c"/>'; }).join('') +
        words(100, 58, 'KEEP WORDS IN HERE')),
      svg(board(18, 16, 120, 70, CREAM) + cookie(52, 51, 17) + words(104, 47, 'FRESH', 'COOKIES') +
        '<circle cx="168" cy="40" r="20" fill="' + G + '"/><path d="M159 40l7 7 12-13" fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<rect x="128" y="76" width="68" height="22" rx="7" fill="' + O + '"/><text x="162" y="91" text-anchor="middle" font-family="Arial" font-weight="800" font-size="9" fill="#fff">Use this design</text>')
    ];
  })();

  function openHelp() {
    var box = ui.root.querySelector('.bbd-help');
    if (!box) {
      box = el('<div class="bbd-help" role="dialog" aria-modal="true" aria-labelledby="bbdHelpTitle">' +
        '<div class="bbd-help-card">' +
          '<div class="bbd-help-head"><h3 id="bbdHelpTitle">How to make your banner</h3>' +
          '<button type="button" class="bbd-icon-btn" data-a="help-close" aria-label="Close help">' + ICON.close + '</button></div>' +
          '<ol class="bbd-help-steps">' + HELP_STEPS.map(function (s, i) {
            return '<li><div class="bbd-help-pic">' + (HELP_PICS[i] || '') + '</div><div class="bbd-help-txt"><span class="bbd-help-n" aria-hidden="true">' + (i + 1) + '</span><div><b>' + s[0] + '</b><p>' + s[1] + '</p></div></div></li>';
          }).join('') + '</ol>' +
          '<p class="bbd-help-more">Ordering more than one banner? They’re listed on the left under <b>Your banners</b>. Tap one to edit it, or tap its <b>×</b> to remove it from your order.</p>' +
          '<button type="button" class="bbd-btn bbd-btn-primary bbd-help-ok" data-a="help-close">Got it</button>' +
        '</div></div>');
      ui.root.appendChild(box);
    }
    box.hidden = false;
    box.querySelector('.bbd-help-ok').focus();
    try { localStorage.setItem('bbdHelpSeen', '1'); } catch (e) {}
  }

  function closeHelp() {
    var box = ui.root.querySelector('.bbd-help');
    if (box) box.hidden = true;
  }

  function importUpload(set) {
    return new Promise(function (resolve) {
      window.fabric.Image.fromURL(set.dataUrl, function (img) {
        if (img && img.width) {
          if (set.edgeColor === undefined) set.edgeColor = edgeColorOf(img.getElement());
          if (!set.bgColor && set.edgeColor) canvas.setBackgroundColor(set.edgeColor);
          var s = Math.min(lw / img.width, lh / img.height);      // whole artwork visible, like Show Full Design
          img.set({ left: lw / 2, top: lh / 2, originX: 'center', originY: 'center', scaleX: s, scaleY: s,
            bbSrcW: img.width, bbSrcH: img.height });
          styleObject(img);
          canvas.add(img);
        }
        resolve();
      });
    });
  }

  function renderHeader() {
    var set = currentSet();
    ui.nowName.textContent = 'Banner ' + (set ? bannerNumber(set) : 1);
    ui.size.textContent = fmtSize(widthIn) + ' × ' + fmtSize(heightIn);
    var many = sets().length > 1;
    var done = ui.root.querySelector('[data-a="done"] .bbd-d-only');
    if (done) done.textContent = many ? 'Use these designs' : 'Use this design';
  }

  // Save the artboard into its banner (preview image + editable layout). Returns false on failure.
  async function commitCurrent(busyText) {
    var o = canvas.getActiveObject();
    if (o && o.isEditing) o.exitEditing();
    canvas.discardActiveObject();
    canvas.requestRenderAll();
    var set = currentSet();
    if (!set || isBlank()) return true;            // nothing to save for this banner
    if (!dirty && set.design) return true;          // unchanged since last save
    if (window.BBBuilder.getActiveSet() !== set) window.BBBuilder.switchTo(set.id);

    var design = snapshotDesign();
    setBusy(busyText || 'Saving Banner ' + bannerNumber(set) + '…');
    try {
      await window.BBBuilder.loadArtworkFile(await designToFile(design));
    } catch (err) {
      console.error('Designer save failed:', err);
    }
    setBusy(null);
    if (set.design !== design) return false;       // upload failed (the builder already told them)
    dirty = false;
    return true;
  }

  function close() {
    if (!ui) return;
    ui.root.hidden = true;
    document.documentElement.classList.remove('bbd-open');
    if (canvas) canvas.discardActiveObject();
    hideQuick();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
    refreshEntry();
  }

  function cancel() {
    if (dirty && !window.confirm('Close the designer? Changes to this banner\'s design will be lost.')) return;
    close();
  }

  async function done() {
    var set = currentSet();
    if (isBlank() && !(set && set.design) && sets().every(function (s) { return !s.design; })) {
      toast('Your banner is blank. Add some text, a shape or an image first.');
      return;
    }
    if (!(await commitCurrent('Preparing your banner…'))) {
      toast('Something went wrong saving your design. Please try again.');
      return;
    }
    close();
  }

  async function goToBanner(id) {
    if (id === currentSetId) return;
    var target = sets().filter(function (s) { return s.id === id; })[0];
    if (!target) return;
    if (!target.design && (target.fileName || target.dataUrl) &&
        !window.confirm('Banner ' + bannerNumber(target) + ' uses a file you uploaded. Design this banner here instead? (Your upload is only replaced if you save a design.)')) return;
    if (!(await commitCurrent())) { toast('Couldn\'t save this banner. Please try again.'); return; }
    setBusy('Opening Banner ' + bannerNumber(target) + '…');
    window.BBBuilder.switchTo(id);
    await loadActive();
  }

  async function removeBanner(id) {
    var list = sets();
    var target = list.filter(function (s) { return s.id === id; })[0];
    if (!target || list.length <= 1) return;
    var n = bannerNumber(target);
    if (!window.confirm('Remove Banner ' + n + ' from your order?')) return;
    var wasCurrent = id === currentSetId;
    if (!window.BBBuilder.removeBanner(id)) { toast('Your order needs at least one banner.'); return; }
    if (wasCurrent) {
      dirty = false;                     // that banner is gone; open the one the builder moved to
      setBusy('Opening your next banner…');
      await loadActive();
    } else {
      renderStrip();
      renderHeader();
    }
    toast('Banner ' + n + ' removed from your order');
  }

  async function newBanner() {
    if (!(await commitCurrent())) { toast('Couldn\'t save this banner. Please try again.'); return; }
    setBusy('Adding a banner…');
    window.BBBuilder.addBanner();
    await loadActive();
    toast('Banner ' + bannerNumber(currentSet()) + ' added to your order');
  }

  /* ---------------- banner size ---------------- */
  var SIZE_PRESETS = [[36, 24], [48, 24], [60, 36], [72, 36], [96, 48], [120, 48]];
  function ftVal(inches) { return Math.round(inches / 12 * 100) / 100; }
  function unitVal(inches) { return sizeUnit === 'in' ? Math.round(inches * 100) / 100 : ftVal(inches); }

  function sizeControls() {
    var price = null;
    try { price = window.BBBuilder.getUnitPrice(); } catch (e) {}
    var inch = sizeUnit === 'in';
    var attrs = inch ? 'min="12" max="600" step="1"' : 'min="1" max="50" step="0.5"';
    var suffix = inch ? 'in' : 'ft';
    return '<div class="bbd-sizes">' + SIZE_PRESETS.map(function (p) {
        var on = Math.abs(p[0] - widthIn) < 0.01 && Math.abs(p[1] - heightIn) < 0.01;
        var label = inch ? p[0] + ' × ' + p[1] + ' in' : (p[0] / 12) + ' × ' + (p[1] / 12) + ' ft';
        return '<button type="button" class="bbd-size-chip' + (on ? ' is-on' : '') + '" data-a="size-preset" data-w="' + p[0] + '" data-h="' + p[1] + '" aria-pressed="' + on + '">' + label + '</button>';
      }).join('') + '</div>' +
      '<div class="bbd-size-head"><span>Custom size</span>' +
        '<div class="bbd-unit" role="group" aria-label="Measure in">' +
          '<button type="button" data-a="size-unit" data-unit="ft" aria-pressed="' + !inch + '">Feet</button>' +
          '<button type="button" data-a="size-unit" data-unit="in" aria-pressed="' + inch + '">Inches</button>' +
        '</div></div>' +
      '<div class="bbd-size-custom">' +
        '<label>Width<span><input type="number" inputmode="decimal" ' + attrs + ' value="' + unitVal(widthIn) + '" data-size="w"> ' + suffix + '</span></label>' +
        '<span class="bbd-size-x" aria-hidden="true">×</span>' +
        '<label>Height<span><input type="number" inputmode="decimal" ' + attrs + ' value="' + unitVal(heightIn) + '" data-size="h"> ' + suffix + '</span></label>' +
      '</div>' +
      (typeof price === 'number' && isFinite(price) ? '<p class="bbd-size-price"><b>$' + price.toFixed(2) + '</b> each at this size</p>' : '');
  }

  // Resize this banner: the order/price update in the builder and the layout scales to fit.
  function setSizeUnit(unit) {
    if (unit !== 'ft' && unit !== 'in') return;
    sizeUnit = unit;
    try { localStorage.setItem('bbdSizeUnit', unit); } catch (e) {}
    renderHeader();
    renderStrip();
    refreshInspector();
  }

  function changeSize(wIn, hIn) {
    var inch = sizeUnit === 'in';
    if (!(wIn >= 12 && hIn >= 12)) { toast(inch ? 'Banners start at 12" on each side.' : 'Banners start at 1 ft on each side.'); refreshInspector(); return; }
    if (wIn > 600 || hIn > 600) { toast(inch ? 'The largest we print is 600" (50 ft) on a side.' : 'The largest we print is 50 ft on a side.'); refreshInspector(); return; }
    if (Math.abs(wIn - widthIn) < 0.01 && Math.abs(hIn - heightIn) < 0.01) return;
    var applied = window.BBBuilder.setBannerSize(wIn, hIn);
    var oldW = lw, oldH = lh;
    widthIn = applied.widthIn; heightIn = applied.heightIn;
    lw = widthIn * UPI; lh = heightIn * UPI;
    canvas.discardActiveObject();
    rescaleLayout(oldW, oldH);
    fit();
    // Undo can't span a resize (the artboard itself changed), so start history fresh here.
    history = []; histIdx = -1; pushHistory();
    dirty = true;
    checkEdges();
    renderHeader();
    renderStrip();
    refreshInspector();
    toast('Now ' + fmtSize(widthIn) + ' × ' + fmtSize(heightIn) + '. Price updated in your order.');
  }

  /* Every banner in the order, in the left column (a row across the top on phones). */
  var stripTimer = null;
  function scheduleStrip() { clearTimeout(stripTimer); stripTimer = setTimeout(renderStrip, 400); }

  function renderStrip() {
    if (!ui || !canvas) return;
    var list = sets();
    var live = '';
    try { live = canvas.toDataURL({ format: 'jpeg', quality: 0.7, multiplier: 160 / Math.max(canvas.getWidth(), 1) }); } catch (e) {}
    canvas.requestRenderAll();   // the export pass skips the safe-line overlay; redraw it

    // Same banners as last time: update in place so a click never lands on a node being replaced.
    var key = list.map(function (s) { return s.id + ':' + (s.config ? s.config.widthIn + 'x' + s.config.heightIn : ''); }).join(',') + '|' + currentSetId;
    if (ui.strip.getAttribute('data-key') === key) {
      var liveImg = ui.strip.querySelector('.bbd-strip-item.is-on .bbd-strip-thumb');
      if (liveImg && live) liveImg.innerHTML = '<img alt="" src="' + live + '">';
      return;
    }
    ui.strip.setAttribute('data-key', key);
    ui.strip.innerHTML =
      list.map(function (s, i) {
        var on = s.id === currentSetId;
        var src = on ? live : (s.dataUrl || '');
        var cfg = s.config || {};
        var size = cfg.widthIn && cfg.heightIn ? fmtSize(cfg.widthIn) + ' × ' + fmtSize(cfg.heightIn) : '';
        var state = on ? 'Editing' : (s.design ? 'Designed' : (s.fileName ? 'Uploaded file' : 'Empty'));
        return '<div class="bbd-strip-cell" role="listitem">' +
          '<button type="button" class="bbd-strip-item' + (on ? ' is-on' : '') + '" data-banner="' + s.id + '" aria-current="' + on + '">' +
          '<span class="bbd-strip-thumb">' + (src ? '<img alt="" src="' + src + '">' : '<i>Empty</i>') + '</span>' +
          '<span class="bbd-strip-copy"><b>Banner ' + (i + 1) + '</b><small>' + state + (size ? ' · ' + size : '') + '</small></span>' +
          '</button>' +
          (list.length > 1 ? '<button type="button" class="bbd-strip-remove" data-a="remove-banner" data-id="' + s.id + '" aria-label="Remove Banner ' + (i + 1) + ' from your order" title="Remove from order">×</button>' : '') +
        '</div>';
      }).join('') +
      '<button type="button" class="bbd-strip-add" data-a="new-banner"><span aria-hidden="true">+</span><b>New banner</b><small>Design another</small></button>';
  }

  function snapshotDesign() {
    return { version: 1, widthIn: widthIn, heightIn: heightIn, json: canvas.toJSON(SAVE_PROPS) };
  }

  function setBusy(text) {
    ui.busy.classList.toggle('is-on', !!text);
    if (text) ui.busyText.textContent = text;
  }

  var toastTimer = null;
  function toast(msg) {
    ui.toast.textContent = msg;
    ui.toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { ui.toast.classList.remove('is-on'); }, 3600);
  }

  /* ---------------- canvas ---------------- */
  function initCanvas(fabric) {
    var touch = isTouch();
    fabric.Object.prototype.set({
      transparentCorners: false,
      cornerColor: '#ffffff',
      cornerStrokeColor: '#fc7321',
      borderColor: '#fc7321',
      cornerStyle: 'circle',
      cornerSize: touch ? 18 : 11,
      touchCornerSize: 40,
      padding: touch ? 8 : 4,
      lockScalingFlip: true,      // pulling a corner past the other side shrinks, never mirrors
      snapAngle: 45,              // rotation clicks into place near straight / 45° / 90°
      snapThreshold: 6,
      minScaleLimit: 0.05,
      borderScaleFactor: 1.5
    });
    canvas = new fabric.Canvas(ui.canvas, {
      preserveObjectStacking: true,
      selection: !touch,           // no drag-to-select box on phones; a finger drag should move things
      allowTouchScrolling: false,
      // A script on the site gives mouse events a `changedTouches` list. Fabric then treats
      // every mouse move as a "second finger" and ignores it, so nothing could be dragged.
      // Only apply the touch check to real touch events.
      _isMainEvent: function (evt) {
        if (evt.isPrimary === true) return true;
        if (evt.isPrimary === false) return false;
        if (!/^touch/.test(evt.type)) return true;
        if (evt.type === 'touchend' && evt.touches && evt.touches.length === 0) return true;
        if (evt.changedTouches && evt.changedTouches[0]) return evt.changedTouches[0].identifier === this.mainTouchId;
        return true;
      },
      backgroundColor: '#ffffff',
      selectionColor: 'rgba(252,115,33,.08)',
      selectionBorderColor: '#fc7321'
    });

    canvas.on('object:added', function (e) { styleObject(e.target); if (!restoring) { dirty = true; pushHistory(); refreshLines(); } });
    canvas.on('object:removed', function () { if (!restoring) { dirty = true; pushHistory(); } });
    canvas.on('object:modified', function (e) {
      normalizeTextScale(e.target);
      guides.v = guides.h = false;
      dirty = true;
      pushHistory();
      refreshInspector();
      checkEdges();
    });
    canvas.on('text:changed', function () { dirty = true; scheduleSave(); checkEdges(); syncTextField(); refreshLines(); });
    canvas.on('object:moving', function (e) { hideQuick(); snapToCenter(e); });
    canvas.on('object:scaling', hideQuick);
    canvas.on('object:rotating', hideQuick);
    canvas.on('text:editing:entered', hideQuick);
    canvas.on('text:editing:exited', function () { refreshLines(); updateQuick(); });
    canvas.on('object:removed', function () { if (!restoring) refreshLines(); });
    canvas.on('mouse:up', function () {
      if (guides.v || guides.h) { guides.v = guides.h = false; canvas.requestRenderAll(); }
      updateQuick();
    });
    canvas.on('selection:created', refreshInspector);
    canvas.on('selection:updated', refreshInspector);
    canvas.on('selection:cleared', refreshInspector);
    canvas.on('after:render', drawOverlay);
    // Touch: double-tap text jumps straight to its word box.
    canvas.on('mouse:dblclick', function (e) {
      if (!isTouch() || !e.target || e.target.type !== 'i-text') return;
      openGroup('words');
      var ta = ui.inspector.querySelector('[data-p="text"]');
      if (ta) { ta.focus(); ta.select(); }
    });

    // Fabric remembers where the canvas sits on screen. Layout shifts (the banner strip,
    // bottom sheets, fonts) move it without a window resize, so re-measure on every press,
    // before Fabric's own handlers run (capture phase on the wrapper).
    ['mousedown', 'touchstart', 'pointerdown'].forEach(function (t) {
      ui.board.addEventListener(t, function () { canvas.calcOffset(); }, { capture: true, passive: true });
    });

    // Text measured before its web font arrived gets a box the wrong width (text looks
    // off-center in its frame). Re-measure everything whenever fonts finish loading.
    if (document.fonts && document.fonts.addEventListener) {
      document.fonts.addEventListener('loadingdone', function () {
        if (!canvas) return;
        fabric.util.clearFabricFontCache();
        canvas.getObjects().forEach(function (o) { if (o.initDimensions) { o.initDimensions(); o.setCoords(); } });
        canvas.requestRenderAll();
        updateQuick();
      });
    }

    if (window.ResizeObserver) new ResizeObserver(function () { if (!ui.root.hidden) fit(); }).observe(ui.stage);
    window.addEventListener('resize', function () { if (!ui.root.hidden) fit(); });
  }

  function styleObject(o) {
    if (!o) return;
    if (o.type === 'i-text' || o.type === 'textbox' || o.type === 'text') {
      o.setControlsVisibility({ mt: false, mb: false, ml: false, mr: false });
      // Draw text live while resizing instead of stretching a cached snapshot
      // (the snapshot looks blurry mid-drag, then "pops" sharp on release).
      o.objectCaching = false;
      // On touch screens words are typed in the sheet's text box: Fabric's hidden
      // in-canvas textarea makes iPhones zoom and jump. (Not serialized.)
      o.editable = !isTouch();
    }
    if (o.type === 'line') o.setControlsVisibility({ mt: false, mb: false });
    // Photos and logos resize from the corners, in proportion. "Free transform" (o.bbFree) adds the
    // side handles so the customer can stretch on purpose; skewing stays off.
    if (o.type === 'image') {
      var free = !!o.bbFree;
      o.setControlsVisibility({ mt: free, mb: free, ml: free, mr: free });
      o.lockSkewingX = o.lockSkewingY = true;
      o.lockScalingFlip = true;
    }
  }

  // Corner-drag on text changes scale; fold it back into font size so the inspector stays truthful.
  function normalizeTextScale(o) {
    if (!o || o.type !== 'i-text') return;
    if (Math.abs(o.scaleX - o.scaleY) > 0.001 || Math.abs(o.scaleX - 1) < 0.001) return;
    var s = o.scaleX;
    o.set({ fontSize: Math.round(o.fontSize * s * 10) / 10, strokeWidth: o.strokeWidth * s, scaleX: 1, scaleY: 1 });
    o.setCoords();
  }

  function fit() {
    if (!canvas || !lw) return;
    var r = ui.stage.getBoundingClientRect();
    var phone = isPhoneLayout();
    var availW = Math.max(100, r.width - (phone ? 28 : 80));
    // Room for the hint + banner strip (and, on phones, the space the bottom sheets slide into).
    var availH = Math.max(100, r.height - (phone ? 110 + window.innerHeight * 0.44 : 90));
    var zoom = Math.min(availW / lw, availH / lh);
    canvas.setDimensions({ width: Math.round(lw * zoom), height: Math.round(lh * zoom) });
    canvas.setZoom(zoom);
    canvas.calcOffset();
    canvas.requestRenderAll();
    updateQuick();
    placeStart();
    requestAnimationFrame(placeStart);
  }

  // Phones: the quick-start panel starts just under the "keep words out" line and fills down to the
  // tool bar, so it never covers the banner or the hint, whatever the screen height.
  function placeStart() {
    if (!ui || !ui.start) return;
    if (!isPhoneLayout()) { ui.start.style.top = ''; return; }
    var hint = ui.root.querySelector('.bbd-stage-hint');
    if (!hint) return;
    var top = hint.getBoundingClientRect().bottom - ui.stage.getBoundingClientRect().top + 8;
    if (top > 8) ui.start.style.top = Math.round(top) + 'px';
  }

  /* ---------- grommet preview (on screen only, never in the print file) ---------- */
  var showGrommets = true;
  try { if (localStorage.getItem('bbdShowGrommets') === '0') showGrommets = false; } catch (e) {}
  var GROMMET_DEFAULT = { enabled: false, sides: { top: true, bottom: true, left: true, right: true }, spacing: '30' };

  function grommetSetting() {
    var g = null;
    try { g = window.BBBuilder.getGrommets(); } catch (e) {}
    return g || GROMMET_DEFAULT;
  }

  // Same placement as the builder's preview: centers 3/4" in from the edge, evenly spaced
  // at no more than the chosen spacing (or just the corners). Returns layout units.
  function grommetPoints() {
    var g = grommetSetting();
    var sides = g.enabled ? g.sides : GROMMET_DEFAULT.sides;
    var spacing = g.enabled ? g.spacing : GROMMET_DEFAULT.spacing;
    var inset = 0.75 * UPI, pts = [], seen = {};
    function along(len) {
      var usable = Math.max(0, len - inset * 2);
      if (spacing === 'corners') return [0, usable];
      var count = Math.max(2, Math.round(usable / (parseInt(spacing, 10) * UPI)) + 1);
      var out = [];
      for (var i = 0; i < count; i++) out.push(usable / (count - 1) * i);
      return out;
    }
    function add(x, y) { var k = Math.round(x) + ',' + Math.round(y); if (!seen[k]) { seen[k] = 1; pts.push([x, y]); } }
    if (sides.top) along(lw).forEach(function (x) { add(x + inset, inset); });
    if (sides.bottom) along(lw).forEach(function (x) { add(x + inset, lh - inset); });
    if (sides.left) along(lh).forEach(function (y) { add(inset, y + inset); });
    if (sides.right) along(lh).forEach(function (y) { add(lw - inset, y + inset); });
    return { pts: pts, real: !!g.enabled, setting: g };
  }

  function drawGrommets(ctx, z) {
    if (!showGrommets) return;
    var info = grommetPoints();
    // True size is a 5/8" ring with a 3/8" hole; keep it at least a few pixels wide when zoomed out.
    var r = Math.max(0.3125 * UPI, 4 / z), hole = r * 0.6;
    ctx.save();
    if (!info.real) ctx.globalAlpha = 0.45;   // grommets are off: show where they'd go, faded
    info.pts.forEach(function (p) {
      var g = ctx.createRadialGradient(p[0] - r * 0.35, p[1] - r * 0.4, r * 0.1, p[0], p[1], r);
      g.addColorStop(0, '#fbfbfb'); g.addColorStop(0.55, '#a9adb3'); g.addColorStop(1, '#5d6268');
      ctx.beginPath(); ctx.arc(p[0], p[1], r, 0, Math.PI * 2); ctx.fillStyle = g; ctx.fill();
      ctx.lineWidth = 1 / z; ctx.strokeStyle = 'rgba(0,0,0,.45)'; ctx.stroke();
      ctx.beginPath(); ctx.arc(p[0], p[1], hole, 0, Math.PI * 2); ctx.fillStyle = 'rgba(12,16,20,.85)'; ctx.fill();
    });
    ctx.restore();
  }

  // "Show grommets" switch, shown in the Your banner settings (desktop panel and the phone Banner sheet).
  function gromControl() {
    var g = grommetSetting();
    var note = !showGrommets ? 'Turn on to see where they’ll be punched.'
      : (g.enabled ? 'Shown where they’ll be punched: ' + (g.label || 'all sides').toLowerCase() + ', ' + (g.spacingLabel || 'every 2–3 feet').toLowerCase() + '.'
        : 'Grommets are off for this banner. The faded ones show where they’d go.') + ' The shaded circles around them are the only spots to keep clear.';
    return '<div class="bbd-grom-set">' +
      '<button type="button" class="bbd-grom-toggle" data-a="toggle-grommets" aria-pressed="' + showGrommets + '"><span class="bbd-grom-switch" aria-hidden="true"></span>Show grommets</button>' +
      '<p class="bbd-grom-note">' + note + '</p>' +
    '</div>';
  }

  function toggleGrommets() {
    showGrommets = !showGrommets;
    try { localStorage.setItem('bbdShowGrommets', showGrommets ? '1' : '0'); } catch (e) {}
    refreshInspector();
    canvas.requestRenderAll();
  }

  function drawOverlay(opt) {
    var ctx = canvas.getContext();
    if (opt && opt.ctx && opt.ctx !== ctx) return;   // exports (thumbnails) get no guides
    var vt = canvas.viewportTransform;
    var s = SAFE_IN * UPI;
    ctx.save();
    ctx.transform(vt[0], vt[1], vt[2], vt[3], vt[4], vt[5]);
    var z = canvas.getZoom();
    // Keep-clear areas: only the spot around each grommet (true size and position), and only when
    // this banner has grommets. The rest of the edge is usable design space.
    var gi = grommetPoints();
    if (gi.real) {
      var cr = GROMMET_CLEAR_IN * UPI;
      ctx.save();
      ctx.beginPath();
      gi.pts.forEach(function (p) { ctx.moveTo(p[0] + cr, p[1]); ctx.arc(p[0], p[1], cr, 0, Math.PI * 2); });
      ctx.clip();
      ctx.fillStyle = 'rgba(232,86,10,.10)';
      ctx.fillRect(0, 0, lw, lh);
      var step = 7 / z;
      ctx.lineWidth = 1.25 / z;
      for (var d = -lh; d < lw; d += step) {
        ctx.strokeStyle = 'rgba(16,24,32,.22)';
        ctx.beginPath(); ctx.moveTo(d, lh); ctx.lineTo(d + lh, 0); ctx.stroke();
        ctx.strokeStyle = 'rgba(255,255,255,.3)';
        ctx.beginPath(); ctx.moveTo(d + step / 2, lh); ctx.lineTo(d + step / 2 + lh, 0); ctx.stroke();
      }
      ctx.restore();
      ctx.lineWidth = 1.25 / z;
      gi.pts.forEach(function (p) {
        ctx.beginPath(); ctx.arc(p[0], p[1], cr, 0, Math.PI * 2);
        ctx.strokeStyle = 'rgba(255,255,255,.8)'; ctx.setLineDash([]); ctx.stroke();
        ctx.strokeStyle = 'rgba(232,86,10,.9)'; ctx.setLineDash([4 / z, 3 / z]); ctx.stroke();
      });
      ctx.setLineDash([]);
    }
    // Thin edge line (hem fold): keep words inside it. Light + dark dashes so it shows on any color.
    ctx.lineWidth = 1 / z;
    ctx.strokeStyle = 'rgba(255,255,255,.6)';
    ctx.strokeRect(s, s, lw - 2 * s, lh - 2 * s);
    ctx.setLineDash([5 / z, 6 / z]);
    ctx.strokeStyle = 'rgba(16,24,32,.4)';
    ctx.strokeRect(s, s, lw - 2 * s, lh - 2 * s);
    ctx.setLineDash([]);
    drawGrommets(ctx, z);
    ctx.strokeStyle = '#e8560a';
    ctx.lineWidth = 1.5 / z;
    if (guides.v) { ctx.beginPath(); ctx.moveTo(lw / 2, 0); ctx.lineTo(lw / 2, lh); ctx.stroke(); }
    if (guides.h) { ctx.beginPath(); ctx.moveTo(0, lh / 2); ctx.lineTo(lw, lh / 2); ctx.stroke(); }
    ctx.restore();
  }

  function snapToCenter(e) {
    var o = e.target;
    var tol = 8 / canvas.getZoom();
    var c = o.getCenterPoint();
    guides.v = Math.abs(c.x - lw / 2) < tol;
    guides.h = Math.abs(c.y - lh / 2) < tol;
    if (guides.v || guides.h) {
      o.setPositionByOrigin(new window.fabric.Point(guides.v ? lw / 2 : c.x, guides.h ? lh / 2 : c.y), 'center', 'center');
      o.setCoords();
    }
  }

  function rescaleLayout(oldW, oldH) { rescaleObjects(canvas.getObjects(), oldW, oldH, lw, lh); }

  // Fit a layout to a new artboard: everything keeps its relative spot and shape; anything that
  // covered the whole old banner (a photo or color band behind everything) covers the new one.
  function rescaleObjects(objs, oldW, oldH, newW, newH) {
    var sx = newW / oldW, sy = newH / oldH, s = Math.min(sx, sy);
    objs.forEach(function (o) {
      o.setCoords();
      var b = o.getBoundingRect(true, true);
      var fullBleed = !o.angle && b.left <= 1 && b.top <= 1 && b.left + b.width >= oldW - 1 && b.top + b.height >= oldH - 1;
      var c = o.getCenterPoint();
      var k = fullBleed ? Math.max(sx, sy) : s;
      o.set({ scaleX: o.scaleX * k, scaleY: o.scaleY * k });
      o.setPositionByOrigin(new window.fabric.Point(c.x * sx, c.y * sy), 'center', 'center');
      normalizeTextScale(o);
      o.setCoords();
    });
  }

  // A designed banner resized in the builder refits its layout to the new size and re-renders,
  // so the preview (and print file) never gets letterboxed with grey "blank" bands.
  var refitTimer = null;
  document.addEventListener('bb:banner-resized', function (e) {
    if (ui && !ui.root.hidden) return;          // the open designer handles its own resizing
    clearTimeout(refitTimer);
    refitTimer = setTimeout(function () { refitDesign(e.detail && e.detail.setId); }, 900);
  });

  async function refitDesign(setId) {
    var b = window.BBBuilder;
    var set = b && b.getActiveSet();
    if (!set || set.id !== setId || !set.design) return;
    var size = b.getBannerSizeInches();
    var d = set.design;
    if (Math.abs(d.widthIn - size.widthIn) < 0.01 && Math.abs(d.heightIn - size.heightIn) < 0.01) return;
    try {
      var fabric = await ensureFabric();
      await ensureFontsFor(d.json);
      var ow = d.widthIn * UPI, oh = d.heightIn * UPI;
      var sc = new fabric.StaticCanvas(null, { width: ow, height: oh, enableRetinaScaling: false, renderOnAddRemove: false });
      await new Promise(function (r) { sc.loadFromJSON(d.json, r); });
      rescaleObjects(sc.getObjects(), ow, oh, size.widthIn * UPI, size.heightIn * UPI);
      var design = { version: 1, widthIn: size.widthIn, heightIn: size.heightIn, json: sc.toJSON(SAVE_PROPS) };
      sc.dispose();
      var file = await designToFile(design);
      if (b.getActiveSet() !== set) return;     // they switched banners meanwhile
      await b.loadArtworkFile(file);
    } catch (err) {
      console.error('Refitting design to new size failed:', err);
    }
  }

  async function designToFile(design) {
    var dw = design.widthIn * UPI, dh = design.heightIn * UPI;
    var m = PREVIEW_SIDE / Math.max(dw, dh);
    var c = await render(design, Math.round(dw * m), Math.round(dh * m));
    var blob = await new Promise(function (r) { c.toBlob(r, 'image/png'); });
    var name = 'Custom design ' + fmtSize(design.widthIn, 'ft').replace(/"/g, 'in') + ' x ' + fmtSize(design.heightIn, 'ft').replace(/"/g, 'in') + '.png';
    var file = new File([blob], name, { type: 'image/png' });
    file.__bbDesign = design;
    return file;
  }

  function checkEdges() {
    if (!ui || !canvas) return;
    var s = SAFE_IN * UPI;
    var gi = grommetPoints(), cr = GROMMET_CLEAR_IN * UPI;
    var onGrommet = false;
    var close = canvas.getObjects().some(function (o) {
      if (o.type !== 'i-text') return false;
      var b = o.getBoundingRect(true, true);
      // Words over a grommet's keep-clear circle get a hole punched through them.
      if (gi.real && gi.pts.some(function (p) {
        var nx = Math.max(b.left, Math.min(p[0], b.left + b.width)), ny = Math.max(b.top, Math.min(p[1], b.top + b.height));
        return (nx - p[0]) * (nx - p[0]) + (ny - p[1]) * (ny - p[1]) < cr * cr;
      })) { onGrommet = true; return true; }
      return b.left < s || b.top < s || b.left + b.width > lw - s || b.top + b.height > lh - s;
    });
    ui.edgeWarn.textContent = onGrommet ? 'Some text is on a grommet' : 'Some text is close to the edge';
    ui.edgeWarn.hidden = !close;
  }

  /* ---------------- history ---------------- */
  function pushHistory() {
    if (restoring || !canvas) return;
    clearTimeout(saveTimer);
    var state = JSON.stringify(canvas.toJSON(SAVE_PROPS));
    if (history[histIdx] === state) return;
    history = history.slice(0, histIdx + 1);
    history.push(state);
    if (history.length > 60) history.shift();
    histIdx = history.length - 1;
    updateHistoryButtons();
    scheduleStrip();
  }
  function scheduleSave() { clearTimeout(saveTimer); saveTimer = setTimeout(pushHistory, 350); }

  function restore(state) {
    restoring = true;
    canvas.loadFromJSON(JSON.parse(state), function () {
      canvas.getObjects().forEach(styleObject);
      canvas.renderAll();
      restoring = false;
      dirty = true;
      refreshInspector();
      checkEdges();
      updateHistoryButtons();
    });
  }
  function undo() { if (histIdx > 0) restore(history[--histIdx]); }
  function redo() { if (histIdx < history.length - 1) restore(history[++histIdx]); }
  function updateHistoryButtons() {
    ui.root.querySelector('[data-a="undo"]').disabled = histIdx <= 0;
    ui.root.querySelector('[data-a="redo"]').disabled = histIdx >= history.length - 1;
  }

  /* ---------------- adding things ---------------- */
  function addText(kind, silent) {
    var fabric = window.fabric;
    var cfg = {
      headline: { text: 'YOUR MESSAGE HERE', fontFamily: 'Anton', size: 0.26, weight: 400 },
      subheading: { text: 'Add a subheading', fontFamily: 'Montserrat', size: 0.12, weight: 700 },
      body: { text: 'Add a line of details', fontFamily: 'Montserrat', size: 0.075, weight: 400 }
    }[kind];
    var t = new fabric.IText(cfg.text, {
      fontFamily: cfg.fontFamily,
      fontWeight: cfg.weight,
      fontSize: Math.max(10, Math.round(lh * cfg.size)),
      fill: '#101820',
      textAlign: 'center',
      originX: 'center',
      originY: 'center',
      left: lw / 2,
      top: lh / 2 + (kind === 'headline' ? 0 : lh * (kind === 'subheading' ? 0.22 : 0.34)),
      strokeWidth: 0,
      strokeUniform: true,
      paintFirst: 'stroke'
    });
    var maxW = (lw - 2 * SAFE_IN * UPI) * 0.92;
    if (t.width > maxW) t.set('fontSize', Math.floor(t.fontSize * maxW / t.width));
    placeInFreeSpot(t);
    loadFont(cfg.fontFamily, cfg.weight).then(function () {
      window.fabric.util.clearFabricFontCache(cfg.fontFamily);
      t.initDimensions(); t.setCoords(); canvas.requestRenderAll();
    });
    canvas.add(t);
    if (!silent) canvas.setActiveObject(t);
    canvas.requestRenderAll();
    return t;
  }

  // New text goes in the next open spot: below the lowest line of text, or above the
  // highest if there's no room below, so it never lands on top of existing words.
  function placeInFreeSpot(t) {
    var others = canvas.getObjects().filter(function (o) { return o !== t && o.type === 'i-text'; });
    if (!others.length) return;
    t.setCoords();
    var h = t.getBoundingRect(true, true).height;
    var gap = Math.max(lh * 0.03, h * 0.15);
    var safe = SAFE_IN * UPI;
    var rects = others.map(function (o) { return o.getBoundingRect(true, true); });
    var bottom = Math.max.apply(null, rects.map(function (r) { return r.top + r.height; }));
    var top = Math.min.apply(null, rects.map(function (r) { return r.top; }));
    var x = t.getCenterPoint().x, y = null;
    if (bottom + gap + h <= lh - safe) y = bottom + gap + h / 2;
    else if (top - gap - h >= safe) y = top - gap - h / 2;
    if (y === null) return;          // banner is full: leave it where it is and let them move it
    t.setPositionByOrigin(new window.fabric.Point(x, y), 'center', 'center');
    t.setCoords();
  }

  function starPoints(r, points, inner) {
    points = points || 5; inner = inner || 0.45;
    var pts = [];
    for (var i = 0; i < points * 2; i++) {
      var rad = i % 2 ? r * inner : r;
      var a = Math.PI / points * i - Math.PI / 2;
      pts.push({ x: r + rad * Math.cos(a), y: r + rad * Math.sin(a) });
    }
    return pts;
  }

  function addShape(kind) {
    var fabric = window.fabric;
    var d = Math.min(lw, lh) * 0.35;
    var base = { left: lw / 2, top: lh / 2, originX: 'center', originY: 'center', fill: '#fc7321', strokeWidth: 0, strokeUniform: true };
    var o;
    if (kind === 'rect') o = new fabric.Rect(Object.assign({ width: d * 1.6, height: d }, base));
    else if (kind === 'rounded') o = new fabric.Rect(Object.assign({ width: d * 1.6, height: d, rx: d * 0.15, ry: d * 0.15 }, base));
    else if (kind === 'circle') o = new fabric.Circle(Object.assign({ radius: d / 2 }, base));
    else if (kind === 'triangle') o = new fabric.Triangle(Object.assign({ width: d, height: d * 0.9 }, base));
    else if (kind === 'star') o = new fabric.Polygon(starPoints(d / 2), base);
    else if (kind === 'burst') o = new fabric.Polygon(starPoints(d * 0.55, 14, 0.78), base);
    else if (kind === 'pill') o = new fabric.Rect(Object.assign({ width: d * 2.2, height: d * 0.7, rx: d * 0.35, ry: d * 0.35 }, base));
    else if (kind === 'banner') o = new fabric.Path('M0 20 H40 V0 H160 V20 H200 L180 50 L200 80 H160 V100 H40 V80 H0 L20 50 Z', Object.assign({}, base, { scaleX: d * 2 / 200, scaleY: d * 0.9 / 100 }));
    else if (kind === 'line') o = new fabric.Line([0, 0, lw * 0.5, 0], Object.assign({}, base, { stroke: '#101820', strokeWidth: Math.max(2, lh * 0.012), fill: null }));
    if (!o) return;
    canvas.add(o);
    canvas.setActiveObject(o);
    canvas.requestRenderAll();
  }

  function addGraphic(id) {
    var g = GRAPHICS.filter(function (x) { return x[0] === id; })[0];
    if (!g) return;
    var size = Math.min(lw, lh) * 0.3;
    var p = new window.fabric.Path(g[2], {
      fill: '#fc7321', fillRule: 'evenodd', strokeWidth: 0, strokeUniform: true, bbKind: 'graphic',
      originX: 'center', originY: 'center'
    });
    var s = size / Math.max(p.width, p.height);
    p.set({ scaleX: s, scaleY: s, left: lw / 2, top: lh / 2 });
    canvas.add(p);
    canvas.setActiveObject(p);
    canvas.requestRenderAll();
  }

  // Full-color graphic from the library. Stored in the design as vector paths, so it prints sharp at any size.
  function addElement(id) {
    var url = elementUrl(id);
    if (!url) return;
    setBusy('Adding graphic…');
    window.fabric.loadSVGFromURL(url, function (objects, options) {
      setBusy(null);
      if (!objects || !objects.length) { toast('That graphic could not be loaded. Please try again.'); return; }
      var g = window.fabric.util.groupSVGElements(objects, options);
      var size = Math.min(lw, lh) * 0.35;
      var s = size / Math.max(g.width, g.height);
      g.set({ bbKind: 'element', bbEl: id, originX: 'center', originY: 'center', scaleX: s, scaleY: s, left: lw / 2, top: lh / 2 });
      canvas.add(g);
      canvas.setActiveObject(g);
      canvas.requestRenderAll();
    });
  }

  // Thumbnails load only when the Images tab is first opened.
  function loadElementThumbs() {
    ui.root.querySelectorAll('.bbd-element img[data-src]').forEach(function (img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
  }

  function addImageFile(file) {
    if (!file || !/^image\/(png|jpe?g|webp)$/i.test(file.type)) { toast('Please choose a PNG, JPG or WebP image.'); return; }
    setBusy('Adding image…');
    var reader = new FileReader();
    reader.onload = function () {
      window.fabric.Image.fromURL(reader.result, function (img) {
        setBusy(null);
        if (!img || !img.width) { toast('That image could not be opened.'); return; }
        var target = Math.min(lw * 0.5 / img.width, lh * 0.6 / img.height);
        img.set({
          left: lw / 2, top: lh / 2, originX: 'center', originY: 'center',
          scaleX: target, scaleY: target, bbSrcW: img.width, bbSrcH: img.height
        });
        styleObject(img);
        if (startUploadPending) {
          // Started with "Use my logo or photo": show it whole and centered on its own background color.
          startUploadPending = false;
          var fitS = Math.min(lw / img.width, lh / img.height);
          img.set({ scaleX: fitS, scaleY: fitS, left: lw / 2, top: lh / 2 });
          var edge = edgeColorOf(img.getElement());
          var set = currentSet();
          if (set) set.edgeColor = edge;
          if (edge) canvas.setBackgroundColor(edge);
          closeStart();
          setTimeout(function () { toast(edge ? 'Placed and matched to your background. Drag a corner to resize.' : 'Placed on your banner. Drag a corner to resize.'); }, 300);
        }
        canvas.add(img);
        canvas.setActiveObject(img);
        canvas.requestRenderAll();
      });
    };
    reader.onerror = function () { setBusy(null); toast('That image could not be read.'); };
    reader.readAsDataURL(file);
  }

  /* ---------------- inspector ----------------
     Built as named groups. Desktop stacks them all; phones show them as chips
     in a bottom sheet with one group open at a time. */
  var activeGroup = {};   // remembered open chip per object type

  function field(label, body, forId) {
    return '<div class="bbd-field"><label' + (forId ? ' for="' + forId + '"' : '') + '>' + label + '</label>' + body + '</div>';
  }
  function range(p, min, max, step, val, out, aria) {
    return '<div class="bbd-range"><input type="range" min="' + min + '" max="' + max + '" step="' + step + '" value="' + val + '" data-p="' + p + '"' + (aria ? ' aria-label="' + aria + '"' : '') + '><output>' + out + '</output></div>';
  }

  function inspectorGroups(o) {
    var g = [];
    var opacity = o.opacity == null ? 1 : o.opacity;
    var opacityField = field('How solid it is', range('opacity', 0.1, 1, 0.05, opacity, Math.round(opacity * 100) + '%'));
    var arrange =
      field('Center it', '<div class="bbd-seg">' + segBtn('center-h', 'Left ↔ right', false, 'Center horizontally') + segBtn('center-v', 'Top ↕ bottom', false, 'Center vertically') + segBtn('center-both', 'Both', false, 'Center on the banner') + '</div>') +
      field('Tilt', '<div class="bbd-seg">' + segBtn('straighten', 'Straighten', false, 'Remove the tilt') +
        '</div><p class="bbd-note">Tilt it with the round handle on top of the box.</p>') +
      field('Layer order', '<div class="bbd-seg">' +
        segBtn('front', 'To front', false, 'Bring to front') + segBtn('forward', 'Forward', false, 'Bring forward') +
        segBtn('backward', 'Back', false, 'Send backward') + segBtn('back', 'To back', false, 'Send to back') + '</div>') +
      '<div class="bbd-row"><button type="button" class="bbd-btn bbd-btn-ghost" data-a="duplicate">Duplicate</button>' +
      '<button type="button" class="bbd-btn bbd-btn-danger" data-a="delete">Delete</button></div>';

    if (o.type === 'i-text') {
      g.push({ id: 'words', label: 'Edit', title: 'Your words', html:
        '<textarea id="bbdText" rows="2" data-p="text" aria-label="Your words">' + escapeHtml(o.text) + '</textarea>' +
        '<p class="bbd-note">Press Enter inside the box for a second line.</p>' });
      g.push({ id: 'font', label: 'Font', title: 'Font selection', html:
        '<button type="button" class="bbd-font-current" data-a="font-toggle" style="font-family:\'' + o.fontFamily + '\'" aria-expanded="false">' + o.fontFamily + '</button>' +
        '<div class="bbd-font-list" data-r2="fontList" hidden>' + FONT_GROUPS.map(function (grp) {
          return '<span class="bbd-font-group">' + grp.label + '</span>' + grp.fonts.map(function (f) {
            return '<button type="button" data-font="' + f + '" class="' + (f === o.fontFamily ? 'is-on' : '') + '" style="font-family:\'' + f + '\'">' + f + '</button>';
          }).join('');
        }).join('') + '</div>' });
      g.push({ id: 'size', label: 'Size', title: 'Text size', html:
        '<p class="bbd-note bbd-note-top"><span class="bbd-hint" data-r2="sizeHint">' + letterHint(o) + '</span></p>' +
        '<div class="bbd-range"><input type="range" min="8" max="' + Math.round(lh * 1.1) + '" step="1" value="' + Math.round(o.fontSize) + '" data-p="fontSize" aria-label="Text size"><input type="number" inputmode="numeric" min="4" step="1" value="' + Math.round(o.fontSize) + '" data-p="fontSize" aria-label="Text size"></div>' });
      g.push({ id: 'style', label: 'Style', title: 'Style & alignment', html: '<div class="bbd-seg">' +
        segBtn('bold', '<b>B</b>', isBold(o), 'Bold') + segBtn('italic', '<i>I</i>', o.fontStyle === 'italic', 'Italic') +
        segBtn('upper', 'AA', o.text === o.text.toUpperCase() && /[A-Z]/.test(o.text), 'All caps') +
        segBtn('align-left', alignIcon('left'), o.textAlign === 'left', 'Align left') +
        segBtn('align-center', alignIcon('center'), o.textAlign === 'center', 'Align center') +
        segBtn('align-right', alignIcon('right'), o.textAlign === 'right', 'Align right') + '</div>' });
      g.push({ id: 'color', label: 'Color', title: 'Text color', html: swatchRow('fill', o.fill) });
      g.push({ id: 'outline', label: 'Outline', title: 'Outline', html: swatchRow('stroke', o.strokeWidth ? o.stroke : '') +
        field('Thickness', range('strokeWidth', 0, Math.max(4, Math.round(o.fontSize * 0.15)), 0.5, o.strokeWidth || 0, o.strokeWidth || 0, 'Outline thickness')) });
      g.push({ id: 'spacing', label: 'Spacing', title: 'Spacing', html:
        field('Between letters', range('charSpacing', -100, 800, 10, o.charSpacing || 0, o.charSpacing || 0)) +
        field('Between lines', range('lineHeight', 0.7, 2, 0.05, o.lineHeight || 1.16, o.lineHeight || 1.16)) });
      g.push({ id: 'effects', label: 'Effects', title: 'Shadow & see-through', html:
        '<label class="bbd-check"><input type="checkbox" data-p="shadow"' + (o.shadow ? ' checked' : '') + '> Drop shadow</label>' + opacityField });
    } else if (o.type === 'image') {
      g.push({ id: 'fit', label: 'Fit', title: 'Fit on the banner', html:
        matchBgControl() +
        '<button type="button" class="bbd-btn bbd-btn-ghost bbd-wide" data-a="img-fit">Show the whole image</button>' +
        '<button type="button" class="bbd-btn bbd-btn-ghost bbd-wide" data-a="img-fill">Fill the banner (trims edges)</button>' +
        '<button type="button" class="bbd-btn bbd-btn-ghost bbd-wide" data-a="img-stretch">Stretch to fit exactly</button>' +
        '<button type="button" class="bbd-grom-toggle" data-a="img-free" aria-pressed="' + !!o.bbFree + '"><span class="bbd-grom-switch" aria-hidden="true"></span>Free transform</button>' +
        '<p class="bbd-note">' + (o.bbFree ? 'Drag the side handles to stretch. Stretching changes the shape of your artwork.'
          : 'Corners keep the shape. Turn on Free transform to stretch it by the sides.') + ' It prints exactly as it looks here.</p>' });
      g.push({ id: 'quality', label: 'Image', title: 'Print quality', html: sharpness(o) +
        '<button type="button" class="bbd-btn bbd-btn-ghost bbd-wide" data-a="flip">Flip horizontally</button>' });
      g.push({ id: 'effects', label: 'See-through', title: 'See-through', html: opacityField });
    } else if (o.bbKind === 'element') {
      g.push({ id: 'look', label: 'Graphic', title: 'Graphic', html:
        '<p class="bbd-note bbd-note-top">Drag a corner to resize. Full-color graphics print sharp at any size.</p>' +
        '<button type="button" class="bbd-btn bbd-btn-ghost bbd-wide" data-a="flip">Flip horizontally</button>' });
      g.push({ id: 'effects', label: 'See-through', title: 'See-through', html: opacityField });
    } else if (o.type === 'line') {
      g.push({ id: 'color', label: 'Color', title: 'Line color', html: swatchRow('stroke', o.stroke) });
      g.push({ id: 'thickness', label: 'Thickness', title: 'Thickness', html: range('strokeWidth', 1, Math.round(lh * 0.1), 0.5, o.strokeWidth, o.strokeWidth, 'Line thickness') });
      g.push({ id: 'effects', label: 'See-through', title: 'See-through', html: opacityField });
    } else if (o.type !== 'activeSelection') {
      g.push({ id: 'fill', label: 'Color', title: (o.bbKind === 'graphic' ? 'Graphic' : 'Shape') + ' color', html: swatchRow('fill', o.fill) });
      g.push({ id: 'outline', label: 'Outline', title: 'Outline', html: swatchRow('stroke', o.strokeWidth ? o.stroke : '') +
        field('Thickness', range('strokeWidth', 0, Math.round(Math.min(lw, lh) * 0.05), 0.5, o.strokeWidth || 0, o.strokeWidth || 0, 'Outline thickness')) });
      if (o.type === 'rect') g.push({ id: 'corners', label: 'Corners', title: 'Rounded corners', html: range('rx', 0, Math.round(Math.min(o.width, o.height) / 2), 1, o.rx || 0, Math.round(o.rx || 0), 'Corner roundness') });
      g.push({ id: 'effects', label: 'See-through', title: 'See-through', html: opacityField });
    } else {
      g.push({ id: 'effects', label: 'See-through', title: 'See-through', html: opacityField });
    }
    g.push({ id: 'arrange', label: 'Arrange', title: 'Position & layers', html: arrange });
    return g;
  }

  function objectTitle(o) {
    if (o.type === 'activeSelection') return o.size() + ' items';
    if (o.bbKind === 'graphic' || o.bbKind === 'element') return 'Graphic';
    return { 'i-text': 'Text', image: 'Image', line: 'Line' }[o.type] || 'Shape';
  }

  function secHead(n, title, extra) {
    return '<div class="bbd-sec-head"><span class="bbd-sec-n" aria-hidden="true">' + n + '</span><span class="bbd-sec-title">' + title + '</span>' + (extra || '') + '</div>';
  }

  var lastInspected = null;
  var bannerSecOpen = null;   // null = automatic (open when nothing is selected)
  function refreshInspector() {
    if (!ui) return;
    var o = canvas && canvas.getActiveObject();
    ui.root.classList.toggle('bbd-has-sel', !!o);
    if (o) ui.root.classList.remove('bbd-sheet-tool');
    // Keep the panel where it was when the same thing is re-selected (e.g. after a drag).
    var keepScroll = o && o === lastInspected ? ui.inspector.scrollTop : 0;
    lastInspected = o || null;

    var bannerOpen = bannerSecOpen != null ? bannerSecOpen : !o;
    var bgSection = '<details class="bbd-sec bbd-sec-bg"' + (bannerOpen ? ' open' : '') + '>' +
      '<summary>' + secHead(1, 'Your banner', '<span class="bbd-sec-sum">' + fmtSize(widthIn) + ' × ' + fmtSize(heightIn) + '</span>') + '</summary>' +
      '<div class="bbd-group-title">Banner size</div>' + sizeControls() +
      '<div class="bbd-group-title bbd-gap-top">Grommets</div>' + gromControl() +
      '<div class="bbd-group-title bbd-gap-top">Background color</div>' + matchBgControl() +
      swatchRow('background', canvas && canvas.backgroundColor) + '</details>';
    var h;
    if (!o) {
      h = bgSection +
        '<section class="bbd-sec">' + secHead(2, 'Add to your banner') +
        '<div class="bbd-quickadd">' +
          '<button type="button" data-a="add-headline" class="bbd-qa-h1"><span>+</span>Add a headline</button>' +
          '<button type="button" data-a="add-subheading" class="bbd-qa-h2"><span>+</span>Add a subheading</button>' +
          '<button type="button" data-a="add-body"><span>+</span>Add body text</button>' +
          '<button type="button" data-a="go-tab" data-tab-go="image"><span>+</span>Add a logo or graphic</button>' +
          '<button type="button" data-a="go-tab" data-tab-go="shapes"><span>+</span>Add a shape</button>' +
        '</div></section>' +
        '<div class="bbd-empty">' +
          '<h3>How to edit</h3>' +
          '<ul><li><b>Move:</b> click and drag anything on the banner</li><li><b>Resize:</b> pull a corner, or use <b>A− / A+</b> above text</li><li><b>Change words:</b> double-click text, or type in the Text tab</li><li><b>Edit it:</b> click it and its settings open here</li></ul>' +
        '</div>' +
        '<div class="bbd-keys"><b>Shortcuts</b><span>Delete removes · Ctrl+D duplicates · Arrow keys nudge · Ctrl+Z undo</span></div>';
    } else {
      var groups = inspectorGroups(o);
      var key = o.type;
      var open = groups.some(function (x) { return x.id === activeGroup[key]; }) ? activeGroup[key] : groups[0].id;
      activeGroup[key] = open;
      h = bgSection +
        '<section class="bbd-sec bbd-sec-sel">' +
        '<div class="bbd-insp-head">' + secHead(2, objectTitle(o) + ' settings') +
          '<div class="bbd-insp-actions">' +
            '<button type="button" class="bbd-icon-btn bbd-m-only" data-a="duplicate" aria-label="Duplicate">' + ICON.copy + '</button>' +
            '<button type="button" class="bbd-icon-btn bbd-m-only bbd-icon-danger" data-a="delete" aria-label="Delete">' + ICON.trash + '</button>' +
            '<button type="button" class="bbd-btn bbd-btn-ghost bbd-m-only bbd-done-sel" data-a="deselect">Done</button>' +
          '</div></div>' +
        '<div class="bbd-chips" role="tablist" aria-label="' + objectTitle(o) + ' settings">' + groups.map(function (x) {
          return '<button type="button" role="tab" class="bbd-chip" data-group="' + x.id + '" aria-selected="' + (x.id === open) + '">' + x.label + '</button>';
        }).join('') + '</div>' +
        groups.map(function (x) {
          return '<div class="bbd-group' + (x.id === open ? ' is-open' : '') + '" data-group-body="' + x.id + '">' +
            '<div class="bbd-group-title">' + x.title + '</div>' + x.html + '</div>';
        }).join('') +
        '</section>';
    }
    ui.inspector.innerHTML = h;
    ui.inspector.scrollTop = keepScroll;
    if (ui.bgSwatches) ui.bgSwatches.innerHTML = matchBgControl() + swatchRow('background', canvas && canvas.backgroundColor);
    if (ui.sizeBox) ui.sizeBox.innerHTML = sizeControls();
    if (ui.gromBox) ui.gromBox.innerHTML = gromControl();
    if (ui.accSize) ui.accSize.textContent = fmtSize(widthIn) + ' × ' + fmtSize(heightIn);
    if (ui.accGrom) ui.accGrom.textContent = showGrommets ? 'Shown' : 'Hidden';
    if (ui.accBg) ui.accBg.innerHTML = '<i style="background:' + (canvas && canvas.backgroundColor || '#fff') + '"></i>';
    refreshStart();
    var sec = ui.inspector.querySelector('.bbd-sec-bg');
    // Remember only a person's click (browsers also fire "toggle" when the section first renders open).
    if (sec) sec.querySelector('summary').addEventListener('click', function () {
      setTimeout(function () { bannerSecOpen = sec.open; }, 0);
    });
    refreshLines();
    updateQuick();
  }

  function openGroup(id) {
    var o = canvas.getActiveObject();
    if (!o) return;
    activeGroup[o.type] = id;
    ui.inspector.querySelectorAll('.bbd-chip').forEach(function (c) { c.setAttribute('aria-selected', String(c.getAttribute('data-group') === id)); });
    ui.inspector.querySelectorAll('.bbd-group').forEach(function (b) { b.classList.toggle('is-open', b.getAttribute('data-group-body') === id); });
    var chip = ui.inspector.querySelector('.bbd-chip[data-group="' + id + '"]');
    if (chip && chip.scrollIntoView) chip.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }

  function logoUrl() {
    var r = document.getElementById('blazing-banner-builder-v43');
    return (r && r.getAttribute('data-bbd-logo')) || '';
  }

  /* ---------------- "Your text" line list ---------------- */
  var lineObjs = [];

  var START_TEXT_COLORS = ['#ffffff', '#101820', '#fc7321', '#e11d2e', '#ffd23f', '#1d4ed8'];

  // Quick-start "Font" button: select the words and open the font list in the text settings.
  function startFont() {
    var t = textObjects()[0];
    if (!t) { addText('headline'); t = textObjects()[0]; if (!t) return; }
    canvas.setActiveObject(t);
    canvas.requestRenderAll();
    refreshInspector();
    openGroup('font');                 // opens with the sheet header (and its Done button) still in view
    ui.inspector.scrollTop = 0;
  }

  // Quick-start text color: one tap recolors all the words on the banner.
  function startTextColor(c) {
    textObjects().forEach(function (t) { t.set('fill', c); });
    canvas.requestRenderAll();
    dirty = true; scheduleSave(); pushHistory();
    refreshStart();
  }

  // Keep the phone quick-start panel in step with the banner (top line of text, background color).
  function refreshStart() {
    if (!ui || !ui.start || !canvas) return;
    var ta = ui.start.querySelector('[data-start-text]');
    var first = textObjects()[0];
    if (ta && document.activeElement !== ta) ta.value = first ? first.text : '';
    if (ui.startFont) ui.startFont.textContent = first ? first.fontFamily : 'Anton';
    if (ui.startFont) ui.startFont.style.fontFamily = first ? "'" + first.fontFamily + "'" : '';
    var fill = first && typeof first.fill === 'string' ? toHex(first.fill) : '';
    ui.startTextColors.innerHTML = '<span class="bbd-start-colors-k">Color</span>' + START_TEXT_COLORS.map(function (c) {
      return '<button type="button" class="bbd-swatch' + (c === fill ? ' is-on' : '') + '" style="background:' + c + '" data-start-color="' + c + '" aria-label="Text color ' + c + '"></button>';
    }).join('');
    var bg = String(canvas.backgroundColor || '').toLowerCase();
    ui.startSwatches.innerHTML = SWATCHES.slice(0, 9).map(function (c) {
      return '<button type="button" class="bbd-swatch' + (c.toLowerCase() === bg ? ' is-on' : '') + '" style="background:' + c + '" data-swatch="background" data-color="' + c + '" aria-label="Background ' + c + '"></button>';
    }).join('');
  }

  function startTyping(value) {
    var t = textObjects()[0];
    if (!t) {
      addText('headline');
      canvas.discardActiveObject();
      refreshInspector();
      t = textObjects()[0];
      if (!t) return;
    }
    t.set('text', value || ' ');
    t.initDimensions(); t.setCoords();
    canvas.requestRenderAll();
    dirty = true; scheduleSave(); checkEdges();
  }

  function textObjects() {
    return canvas.getObjects().filter(function (o) { return o.type === 'i-text'; })
      .sort(function (a, b) { return a.getBoundingRect(true, true).top - b.getBoundingRect(true, true).top; });
  }

  function refreshLines() {
    if (!ui || !canvas) return;
    var texts = textObjects();
    var active = canvas.getActiveObject();
    var focused = ui.lines.contains(document.activeElement);
    var same = texts.length === lineObjs.length && texts.every(function (t, i) { return t === lineObjs[i]; });
    if (focused && same) {
      // Don't rebuild under the cursor; just keep the other rows in step.
      ui.lines.querySelectorAll('textarea').forEach(function (ta, i) {
        if (ta !== document.activeElement && ta.value !== texts[i].text) ta.value = texts[i].text;
        ta.parentNode.classList.toggle('is-on', texts[i] === active);
      });
      return;
    }
    lineObjs = texts;
    if (!texts.length) {
      ui.lines.innerHTML = '<p class="bbd-lines-empty">No text yet. Add a headline above.</p>';
      return;
    }
    ui.lines.innerHTML = texts.map(function (t, i) {
      return '<div class="bbd-line' + (t === active ? ' is-on' : '') + '">' +
        '<span class="bbd-line-n" aria-hidden="true">' + (i + 1) + '</span>' +
        '<textarea rows="' + Math.max(1, t.text.split('\n').length) + '" data-line="' + i + '" aria-label="Text line ' + (i + 1) + '" style="font-family:\'' + t.fontFamily + '\'">' + escapeHtml(t.text) + '</textarea>' +
        '<button type="button" class="bbd-line-x" data-a="line-delete" data-line="' + i + '" aria-label="Delete line ' + (i + 1) + '">' + ICON.close + '</button>' +
      '</div>';
    }).join('');
    ui.lines.querySelectorAll('textarea').forEach(growToFit);
  }

  // Line boxes grow with their words so long lines never get cut off.
  function growToFit(ta) {
    if (ta.offsetParent === null) { ta.style.height = ''; return; }   // hidden tab: measured when shown
    ta.style.height = 'auto';
    ta.style.height = ta.scrollHeight + 'px';
  }

  function addLine(after) {
    var texts = textObjects();
    var ref = after || texts[texts.length - 1];
    var t = addText('body', true);
    if (ref) {
      var rb = ref.getBoundingRect(true, true);
      t.set({ fontFamily: ref.fontFamily, fontWeight: ref.fontWeight, fill: ref.fill, fontSize: Math.max(10, Math.round(ref.fontSize * 0.6)), text: 'New line' });
      t.initDimensions();
      t.setPositionByOrigin(new window.fabric.Point(rb.left + rb.width / 2, t.getCenterPoint().y), 'center', 'center');
      placeInFreeSpot(t);
    }
    canvas.requestRenderAll();
    refreshLines();
    var idx = lineObjs.indexOf(t);
    var ta = ui.lines.querySelector('[data-line="' + idx + '"]');
    if (ta) { ta.focus(); ta.select(); }
    return t;
  }

  /* ---------------- floating quick bar above the selection (desktop) ---------------- */
  function hideQuick() { if (ui) ui.quick.hidden = true; }

  function updateQuick() {
    if (!ui || !canvas) return;
    var o = canvas.getActiveObject();
    if (!o || o.isEditing || isPhoneLayout()) return hideQuick();
    var isText = o.type === 'i-text';
    // Centering: left-right, top-bottom, and dead center on the banner.
    var ALIGN = '<i></i>' +
      '<button type="button" data-a="center-h" title="Center left to right" aria-label="Center left to right"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12 3v18" stroke="currentColor" stroke-width="2"/><rect x="5" y="7" width="14" height="10" rx="2" fill="none" stroke="currentColor" stroke-width="2"/></svg></button>' +
      '<button type="button" data-a="center-v" title="Center top to bottom" aria-label="Center top to bottom"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M3 12h18" stroke="currentColor" stroke-width="2"/><rect x="7" y="5" width="10" height="14" rx="2" fill="none" stroke="currentColor" stroke-width="2"/></svg></button>' +
      '<button type="button" data-a="center-both" title="Center on the banner" aria-label="Center on the banner"><svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2" fill="none" stroke="currentColor" stroke-width="2"/><circle cx="12" cy="12" r="3" fill="currentColor"/><path d="M12 3v4M12 17v4M3 12h4M17 12h4" stroke="currentColor" stroke-width="2"/></svg></button>';
    ui.quick.innerHTML = isText
      ? '<button type="button" data-a="size-down" title="Smaller text" aria-label="Smaller text">A−</button>' +
        '<span class="bbd-quick-size" title="Letter height">' + letterHint(o).replace('≈ ', '').replace(' tall letters', '') + '</span>' +
        '<button type="button" data-a="size-up" title="Bigger text" aria-label="Bigger text">A+</button><i></i>' +
        '<button type="button" data-a="quick-font" class="bbd-quick-font" title="Change font" style="font-family:\'' + o.fontFamily + '\'">' + o.fontFamily + '</button>' +
        '<button type="button" data-a="quick-color" class="bbd-quick-color" title="Text color" aria-label="Text color"><span style="background:' + o.fill + '"></span></button>' + ALIGN + '<i></i>' +
        '<button type="button" data-a="duplicate" title="Duplicate" aria-label="Duplicate">' + ICON.copy + '</button>' +
        '<button type="button" data-a="delete" title="Delete" aria-label="Delete" class="is-danger">' + ICON.trash + '</button>'
      : '<button type="button" data-a="front" title="Bring to front">Front</button>' +
        '<button type="button" data-a="back" title="Send to back">Back</button>' + ALIGN + '<i></i>' +
        '<button type="button" data-a="duplicate" title="Duplicate" aria-label="Duplicate">' + ICON.copy + '</button>' +
        '<button type="button" data-a="delete" title="Delete" aria-label="Delete" class="is-danger">' + ICON.trash + '</button>';
    ui.quick.hidden = false;

    var stageBox = ui.stage.getBoundingClientRect();
    var canvasBox = canvas.upperCanvasEl.getBoundingClientRect();
    var r = o.getBoundingRect();
    var qw = ui.quick.offsetWidth, qh = ui.quick.offsetHeight;
    var x = canvasBox.left - stageBox.left + r.left + r.width / 2 - qw / 2;
    // Sit above the rotate handle (it sticks out ~40px over the box), never on top of it;
    // if there's no room up there, go under the box instead.
    var rotateClear = 40 + (o.cornerSize || 11) / 2 + 10;
    var y = canvasBox.top - stageBox.top + r.top - rotateClear - qh;
    if (y < 8) y = canvasBox.top - stageBox.top + r.top + r.height + 14;
    x = Math.max(8, Math.min(stageBox.width - qw - 8, x));
    y = Math.max(8, Math.min(stageBox.height - qh - 8, y));
    ui.quick.style.transform = 'translate(' + Math.round(x) + 'px,' + Math.round(y) + 'px)';
  }

  // Jump the inspector to a group (desktop: scroll to it and flash; phone: open its chip).
  function focusGroup(id) {
    openGroup(id);
    var body = ui.inspector.querySelector('[data-group-body="' + id + '"]');
    if (!body) return;
    body.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    body.classList.remove('bbd-flash');
    void body.offsetWidth;
    body.classList.add('bbd-flash');
  }

  function segBtn(a, label, on, title) {
    return '<button type="button" data-a="' + a + '" class="' + (on ? 'is-on' : '') + '" title="' + title + '" aria-label="' + title + '" aria-pressed="' + !!on + '">' + label + '</button>';
  }
  function alignIcon(side) {
    var lines = { left: 'M4 6h16M4 10h10M4 14h16M4 18h10', center: 'M4 6h16M7 10h10M4 14h16M7 18h10', right: 'M4 6h16M10 10h10M4 14h16M10 18h10' }[side];
    return '<svg viewBox="0 0 24 24"><path d="' + lines + '"/></svg>';
  }
  function isBold(o) { return Number(o.fontWeight) >= 700 || o.fontWeight === 'bold'; }
  function escapeHtml(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // After a background change, any text that nearly vanishes into it (e.g. dark words on a
  // dark banner) flips to white or near-black, whichever reads better. Deliberate low-contrast
  // styling above ~1.6:1 is left alone.
  function luminance(hex) {
    var n = parseInt(toHex(hex).slice(1), 16), c = [n >> 16 & 255, n >> 8 & 255, n & 255].map(function (x) {
      x /= 255; return x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  }
  function contrast(a, b) { var la = luminance(a), lb = luminance(b); return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05); }
  function keepTextReadable(bg) {
    if (typeof bg !== 'string') return;
    textObjects().forEach(function (t) {
      if (typeof t.fill !== 'string' || contrast(t.fill, bg) >= 1.6) return;
      t.set('fill', contrast('#ffffff', bg) >= contrast('#101820', bg) ? '#ffffff' : '#101820');
    });
  }

  function letterHint(o) {
    var capIn = o.fontSize * o.scaleY * 0.72 / UPI;
    return '≈ ' + (capIn >= 10 ? Math.round(capIn) : Math.round(capIn * 10) / 10) + '" tall letters';
  }

  function sharpness(o) {
    var printedIn = o.getScaledWidth() / UPI;
    var dpi = Math.round((o.bbSrcW || o.width) / Math.max(printedIn, 0.01));
    var level = dpi >= 100 ? ['good', 'Sharp'] : dpi >= 50 ? ['ok', 'Good from a few feet away'] : ['low', 'May look soft up close. Try a larger file or make it smaller'];
    return '<div class="bbd-sharp bbd-sharp-' + level[0] + '"><b>' + level[1] + '</b><span>' + dpi + ' DPI at this size</span></div>';
  }

  function syncTextField() {
    var o = canvas.getActiveObject();
    var ta = ui.inspector.querySelector('[data-p="text"]');
    if (o && ta && document.activeElement !== ta) ta.value = o.text;
  }

  function applyProp(p, v, fromInput, sliding) {
    var o = canvas.getActiveObject();
    if (p === 'background') {
      canvas.setBackgroundColor(v, function () { canvas.requestRenderAll(); });
      keepTextReadable(v);
      dirty = true; scheduleSave();
      if (!fromInput) refreshInspector();
      return;
    }
    if (!o) return;
    var targets = o.type === 'activeSelection' ? o.getObjects() : [o];
    targets.forEach(function (t) {
      if (p === 'fontSize' || p === 'strokeWidth' || p === 'charSpacing' || p === 'lineHeight' || p === 'opacity') t.set(p, parseFloat(v) || 0);
      else if (p === 'rx') t.set({ rx: parseFloat(v) || 0, ry: parseFloat(v) || 0 });
      else if (p === 'text') t.set('text', v);
      else if (p === 'shadow') t.set('shadow', v ? new window.fabric.Shadow({ color: 'rgba(0,0,0,.45)', blur: t.fontSize * 0.08, offsetX: t.fontSize * 0.04, offsetY: t.fontSize * 0.04 }) : null);
      else if (p === 'stroke') {
        t.set('stroke', v);
        if (t.type !== 'line' && !t.strokeWidth) t.set('strokeWidth', t.type === 'i-text' ? Math.max(1, t.fontSize * 0.04) : 4);
      } else t.set(p, v);
      if (t.initDimensions && (p === 'fontSize' || p === 'text' || p === 'charSpacing' || p === 'lineHeight' || p === 'strokeWidth')) t.initDimensions();
      t.setCoords();
    });
    canvas.requestRenderAll();
    dirty = true;
    scheduleSave();
    if (sliding) {
      // Mid-drag on a slider: only redraw. Lists, toolbar and edge checks catch up on release.
      hideQuick();
      var sizeHint = ui.inspector.querySelector('[data-r2="sizeHint"]');
      if (sizeHint && o.type === 'i-text') sizeHint.textContent = letterHint(o);
      return;
    }
    checkEdges();
    if (fromInput) {
      var hint = ui.inspector.querySelector('[data-r2="sizeHint"]');
      if (hint && o.type === 'i-text') hint.textContent = letterHint(o);
      refreshLines();
      updateQuick();
    } else {
      refreshInspector();
    }
  }

  async function setFont(family) {
    var o = canvas.getActiveObject();
    if (!o || o.type !== 'i-text') return;
    setBusy('Loading font…');
    await loadFont(family, o.fontWeight, o.fontStyle);
    setBusy(null);
    window.fabric.util.clearFabricFontCache(family);
    o.set('fontFamily', family);
    o.initDimensions(); o.setCoords();
    canvas.requestRenderAll();
    dirty = true; pushHistory(); checkEdges();
    refreshInspector();
  }

  function action(a, btn) {
    var o = canvas.getActiveObject();
    switch (a) {
      case 'undo': return undo();
      case 'redo': return redo();
      case 'cancel': return cancel();
      case 'deselect': canvas.discardActiveObject(); canvas.requestRenderAll(); return;
      case 'add-line': return addLine();
      case 'add-graphic': return addGraphic(btn.getAttribute('data-g'));
      case 'add-element': return addElement(btn.getAttribute('data-el'));
      case 'new-banner': return newBanner();
      case 'remove-banner': return removeBanner(+btn.getAttribute('data-id'));
      case 'match-bg': return matchBackground();
      case 'help': return openHelp();
      case 'help-close': return closeHelp();
      case 'size-preset': return changeSize(+btn.getAttribute('data-w'), +btn.getAttribute('data-h'));
      case 'size-unit': return setSizeUnit(btn.getAttribute('data-unit'));
      case 'toggle-grommets': return toggleGrommets();
      case 'start-font': return startFont();
      case 'go-tab': return isPhoneLayout() ? tapTab(btn.getAttribute('data-tab-go')) : selectTab(btn.getAttribute('data-tab-go'));
      case 'line-delete': {
        var gone = lineObjs[+btn.getAttribute('data-line')];
        if (gone) { canvas.remove(gone); canvas.discardActiveObject(); canvas.requestRenderAll(); refreshLines(); checkEdges(); }
        return;
      }
      case 'quick-font': return focusGroup('font');
      case 'quick-color': return focusGroup('color');
      case 'done': return done();
      case 'add-headline': return addText('headline');
      case 'add-subheading': return addText('subheading');
      case 'add-body': return addText('body');
      case 'add-shape': return addShape(btn.getAttribute('data-shape'));
      case 'add-image': return ui.imageInput.click();
      case 'font-toggle': {
        var list = ui.inspector.querySelector('[data-r2="fontList"]');
        list.hidden = !list.hidden;
        btn.setAttribute('aria-expanded', String(!list.hidden));
        return;
      }
    }
    if (!o) return;
    var fabric = window.fabric;
    switch (a) {
      case 'bold': o.set('fontWeight', isBold(o) ? 400 : 700); loadFont(o.fontFamily, o.fontWeight, o.fontStyle).then(function () { o.initDimensions(); canvas.requestRenderAll(); }); break;
      case 'italic': o.set('fontStyle', o.fontStyle === 'italic' ? 'normal' : 'italic'); loadFont(o.fontFamily, o.fontWeight, o.fontStyle).then(function () { o.initDimensions(); canvas.requestRenderAll(); }); break;
      case 'upper': o.set('text', o.text === o.text.toUpperCase() ? o.text.toLowerCase().replace(/(^|\s)\S/g, function (m) { return m.toUpperCase(); }) : o.text.toUpperCase()); break;
      case 'align-left': case 'align-center': case 'align-right': o.set('textAlign', a.slice(6)); break;
      case 'center-h': o.setPositionByOrigin(new fabric.Point(lw / 2, o.getCenterPoint().y), 'center', 'center'); break;
      case 'center-v': o.setPositionByOrigin(new fabric.Point(o.getCenterPoint().x, lh / 2), 'center', 'center'); break;
      case 'center-both': o.setPositionByOrigin(new fabric.Point(lw / 2, lh / 2), 'center', 'center'); break;
      case 'front': canvas.bringToFront(o); break;
      case 'forward': canvas.bringForward(o); break;
      case 'backward': canvas.sendBackwards(o); break;
      case 'back': canvas.sendToBack(o); break;
      case 'flip': o.set('flipX', !o.flipX); break;
      case 'straighten': o.rotate(0); break;
      case 'size-up': case 'size-down': {
        if (o.type !== 'i-text') return;
        var fs = Math.max(4, Math.round(o.fontSize * (a === 'size-up' ? 1.12 : 1 / 1.12)));
        o.set({ fontSize: fs, strokeWidth: o.strokeWidth ? o.strokeWidth * fs / o.fontSize : 0 });
        break;
      }
      case 'img-fill': {
        var s = Math.max(lw / o.width, lh / o.height);
        o.set({ scaleX: s, scaleY: s, angle: 0 });
        o.setPositionByOrigin(new fabric.Point(lw / 2, lh / 2), 'center', 'center');
        canvas.sendToBack(o);
        break;
      }
      case 'img-fit': {                      // whole artwork visible, centered, in proportion
        var sf = Math.min(lw / o.width, lh / o.height);
        o.set({ scaleX: sf, scaleY: sf, angle: 0 });
        o.setPositionByOrigin(new fabric.Point(lw / 2, lh / 2), 'center', 'center');
        break;
      }
      case 'img-stretch': {                  // exactly the banner's size: changes the artwork's shape
        o.set({ scaleX: lw / o.width, scaleY: lh / o.height, angle: 0, bbFree: true });
        o.setPositionByOrigin(new fabric.Point(lw / 2, lh / 2), 'center', 'center');
        styleObject(o);
        canvas.sendToBack(o);
        toast('Stretched to fill the banner. It prints exactly like this.');
        break;
      }
      case 'img-free': {                     // unlock the side handles for free stretching
        o.bbFree = !o.bbFree;
        styleObject(o);
        toast(o.bbFree ? 'Free transform on: drag the side handles to stretch' : 'Proportions locked: corners keep the shape');
        break;
      }
      case 'duplicate': return duplicate();
      case 'delete': return removeSelected();
    }
    if (o.initDimensions) o.initDimensions();
    o.setCoords();
    canvas.requestRenderAll();
    dirty = true; pushHistory(); checkEdges();
    refreshInspector();
  }

  function duplicate() {
    var o = canvas.getActiveObject();
    if (!o) return;
    o.clone(function (c) {
      canvas.discardActiveObject();
      var off = Math.min(lw, lh) * 0.04;
      c.set({ left: c.left + off, top: c.top + off, evented: true });
      if (c.type === 'activeSelection') {
        c.canvas = canvas;
        c.forEachObject(function (obj) { canvas.add(obj); });
        c.setCoords();
      } else {
        canvas.add(c);
      }
      canvas.setActiveObject(c);
      canvas.requestRenderAll();
    }, SAVE_PROPS);
  }

  function removeSelected() {
    var o = canvas.getActiveObject();
    if (!o) return;
    restoring = true;
    (o.type === 'activeSelection' ? o.getObjects() : [o]).forEach(function (t) { canvas.remove(t); });
    restoring = false;
    canvas.discardActiveObject();
    canvas.requestRenderAll();
    dirty = true; pushHistory(); checkEdges();
  }

  function selectTab(id) {
    ui.root.querySelectorAll('.bbd-tab').forEach(function (t) { t.setAttribute('aria-selected', String(t.getAttribute('data-tab') === id)); });
    ui.root.querySelectorAll('.bbd-pane').forEach(function (p) { p.hidden = p.getAttribute('data-pane') !== id; });
    if (id === 'text') ui.lines.querySelectorAll('textarea').forEach(growToFit);
    if (id === 'image') loadElementThumbs();
  }

  // Phone: the tool bar opens a bottom sheet; tapping the open tool again closes it.
  function tapTab(id) {
    if (!isPhoneLayout()) return selectTab(id);
    var current = ui.root.querySelector('.bbd-tab[aria-selected="true"]');
    var isOpen = ui.root.classList.contains('bbd-sheet-tool');
    if (isOpen && current && current.getAttribute('data-tab') === id) {
      ui.root.classList.remove('bbd-sheet-tool');
      current.setAttribute('aria-selected', 'false');
      return;
    }
    if (canvas.getActiveObject()) { canvas.discardActiveObject(); canvas.requestRenderAll(); }
    selectTab(id);
    ui.root.classList.add('bbd-sheet-tool');
  }

  var slidePending = {}, slideFrame = 0;

  function bindUI() {
    var root = ui.root;
    // The theme's swipe script (swipe-listener) watches every press on the page and cancels
    // mouse moves while "swiping" — that froze slider drags. Presses inside the designer
    // stop here; Fabric's own canvas handlers have already run at the target.
    ['mousedown', 'touchstart'].forEach(function (t) {
      root.addEventListener(t, function (e) { e.stopPropagation(); }, { passive: true });
    });
    root.addEventListener('click', function (e) {
      // Logo goes home, but nothing here is saved yet, so check before throwing work away.
      if (e.target.closest('.bbd-home')) {
        var sets = [];
        try { sets = window.BBBuilder.getSets() || []; } catch (err) {}
        var hasWork = dirty || (canvas && canvas.getObjects().length) || sets.some(function (s) { return s.dataUrl || s.design; });
        if (hasWork && !window.confirm('Go to the homepage? Your banner isn\'t in your cart yet, so this design will be lost.')) e.preventDefault();
        return;
      }
      var tab = e.target.closest('[data-tab]');
      if (tab) return tapTab(tab.getAttribute('data-tab'));
      var bannerTile = e.target.closest('[data-banner]');
      if (bannerTile) return goToBanner(+bannerTile.getAttribute('data-banner'));
      var chip = e.target.closest('[data-group]');
      if (chip) return openGroup(chip.getAttribute('data-group'));
      var sc = e.target.closest('[data-start-color]');
      if (sc) return startTextColor(sc.getAttribute('data-start-color'));
      var sw = e.target.closest('[data-swatch]');
      if (sw) return applyProp(sw.getAttribute('data-swatch'), sw.getAttribute('data-color'));
      var font = e.target.closest('[data-font]');
      if (font) return setFont(font.getAttribute('data-font'));
      var b = e.target.closest('[data-a]');
      if (b && !b.disabled) action(b.getAttribute('data-a'), b);
    });
    // "Your text" rows: typing edits that line on the banner.
    root.addEventListener('focusin', function (e) {
      var i = e.target.getAttribute && e.target.getAttribute('data-line');
      if (i == null || e.target.tagName !== 'TEXTAREA') return;
      var t = lineObjs[+i];
      ui.lines.querySelectorAll('.bbd-line').forEach(function (row, k) { row.classList.toggle('is-on', k === +i); });
      // Phones keep the text sheet open while typing; desktop also selects it on the banner.
      if (t && !isPhoneLayout() && canvas.getActiveObject() !== t) { canvas.setActiveObject(t); canvas.requestRenderAll(); refreshInspector(); }
    });
    root.addEventListener('keydown', function (e) {
      var i = e.target.getAttribute && e.target.getAttribute('data-line');
      if (i == null || e.key !== 'Enter' || e.shiftKey) return;
      e.preventDefault();   // Enter = new line of its own; Shift+Enter = line break inside this one
      addLine(lineObjs[+i]);
    });
    root.addEventListener('input', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-start-text')) return startTyping(e.target.value);
      var li = e.target.getAttribute('data-line');
      if (li != null && e.target.tagName === 'TEXTAREA') {
        var t = lineObjs[+li];
        if (!t) return;
        t.set('text', e.target.value);
        t.initDimensions(); t.setCoords();
        growToFit(e.target);
        canvas.requestRenderAll();
        dirty = true; scheduleSave(); checkEdges(); syncTextField(); updateQuick();
        return;
      }
      var p = e.target.getAttribute('data-p');
      if (!p) return;
      var v = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
      if (e.target.type === 'range') {
        // Sliders fire faster than the screen refreshes: apply at most once per frame.
        slidePending[p] = v;
        if (!slideFrame) slideFrame = requestAnimationFrame(function () {
          slideFrame = 0;
          Object.keys(slidePending).forEach(function (k) { applyProp(k, slidePending[k], true, true); });
          slidePending = {};
        });
      } else {
        applyProp(p, v, true);
      }
      // keep paired range/number inputs and readouts in step
      var wrap = e.target.closest('.bbd-range');
      if (wrap) {
        wrap.querySelectorAll('[data-p="' + p + '"]').forEach(function (i) { if (i !== e.target) i.value = v; });
        var out = wrap.querySelector('output');
        if (out) out.textContent = p === 'opacity' ? Math.round(v * 100) + '%' : v;
      }
    });
    root.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-start-text')) { pushHistory(); refreshLines(); return; }
      if (e.target.hasAttribute('data-size')) {
        var box = e.target.closest('.bbd-size-custom');
        var w = parseFloat(box.querySelector('[data-size="w"]').value);
        var h = parseFloat(box.querySelector('[data-size="h"]').value);
        // Nobody orders a 36 ft banner: a number over 50 in feet mode means inches, so switch for them.
        if (sizeUnit === 'ft' && (w > 50 || h > 50) && w <= 600 && h <= 600) {
          sizeUnit = 'in';
          try { localStorage.setItem('bbdSizeUnit', 'in'); } catch (err) {}
          if (w <= 50 && e.target.getAttribute('data-size') === 'h') w *= 12;   // untouched side stays the same size
          if (h <= 50 && e.target.getAttribute('data-size') === 'w') h *= 12;
          renderHeader();
          refreshInspector();
        }
        var f = sizeUnit === 'in' ? 1 : 12;
        return changeSize(Math.round(w * f * 100) / 100, Math.round(h * f * 100) / 100);
      }
      var p = e.target.getAttribute('data-p');
      if (p === 'shadow') applyProp(p, e.target.checked);
      else if (p) {
        pushHistory();
        if (e.target.type === 'color') refreshInspector();
        else { checkEdges(); refreshLines(); updateQuick(); }   // slider released: catch up
      }
    });
    ui.imageInput.addEventListener('change', function () {
      addImageFile(ui.imageInput.files[0]);
      ui.imageInput.value = '';
    });

    // Drop an image straight onto the artboard.
    ui.stage.addEventListener('dragover', function (e) { e.preventDefault(); });
    ui.stage.addEventListener('drop', function (e) {
      e.preventDefault();
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) addImageFile(f);
    });

    document.addEventListener('keydown', function (e) {
      if (ui.root.hidden || !canvas) return;
      var o = canvas.getActiveObject();
      var typing = /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName) || (o && o.isEditing);
      var mod = e.ctrlKey || e.metaKey;
      if (mod && e.key.toLowerCase() === 'z' && !typing) { e.preventDefault(); e.shiftKey ? redo() : undo(); return; }
      if (mod && e.key.toLowerCase() === 'y' && !typing) { e.preventDefault(); redo(); return; }
      if (typing) return;
      if (e.key === 'Escape') {
        if (o) { canvas.discardActiveObject(); canvas.requestRenderAll(); } else cancel();
        return;
      }
      if (!o) return;
      if (e.key === 'Delete' || e.key === 'Backspace') { e.preventDefault(); removeSelected(); return; }
      if (mod && e.key.toLowerCase() === 'd') { e.preventDefault(); duplicate(); return; }
      var step = e.shiftKey ? UPI : UPI / 10; // 1" or 0.1"
      var dx = { ArrowLeft: -step, ArrowRight: step }[e.key] || 0;
      var dy = { ArrowUp: -step, ArrowDown: step }[e.key] || 0;
      if (dx || dy) {
        e.preventDefault();
        o.set({ left: o.left + dx, top: o.top + dy });
        o.setCoords();
        canvas.requestRenderAll();
        dirty = true; scheduleSave(); checkEdges();
      }
    });
  }

  /* ---------------- entry points in the builder ----------------
     1) "Design Banner" in the banner tabs row (always visible, above the preview)
     2) "Design it here instead" card in Step 2 (Artwork)
     3) "Design it here" button on the empty banner preview */
  function activeState() {
    var set = window.BBBuilder && window.BBBuilder.getActiveSet();
    if (!set) return 'empty';
    if (set.design) return 'design';
    return (set.fileName || set.dataUrl) ? 'upload' : 'empty';
  }

  function refreshEntry() {
    var btn = document.getElementById('bbdEntry');
    if (!btn || !window.BBBuilder) return;
    var state = activeState();
    var has = state === 'design';
    var up = state === 'upload';
    btn.querySelector('strong').textContent = has ? 'Edit your design' : up ? 'Adjust your file in the editor' : 'Design it here instead';
    btn.querySelector('small').textContent = has ? 'Change text, colors, shapes or images'
      : up ? 'Resize, move, match the background, add text. What you see is what prints'
      : 'No file? Add text, colors, shapes and logos';
    btn.classList.toggle('is-editing', has || up);
    var cta = document.getElementById('bbdPhoneCta');
    if (cta) cta.hidden = activeState() !== 'empty';
    var nav = document.getElementById('bbdNavDesign');
    if (nav) {
      nav.classList.toggle('is-design', has || up);   // phones show it once there's something to edit
      nav.querySelector('.bbd-nav-label').textContent = has || up ? 'Edit Banner' : 'Design Banner';
      nav.querySelector('.bbd-nav-short').textContent = has || up ? 'Edit' : 'Design';
    }
  }

  function designNewBanner() {
    var add = document.getElementById('bannerSimpleAdd');
    if (!add) return open();
    add.click();                       // builder adds a banner and makes it active
    setTimeout(function () { refreshEntry(); open(); }, 60);
  }

  var menu = null;
  function closeMenu() { if (menu) { menu.remove(); menu = null; } }
  function showMenu(anchor) {
    closeMenu();
    var state = activeState();
    var items = state === 'design'
      ? [['edit', 'Edit this banner\'s design', 'Change its text, colors or images'], ['new', 'Design a new banner', 'Adds another banner to this order']]
      : [['new', 'Design a new banner', 'Adds another banner to this order'], ['edit', 'Replace this artwork with a design', 'Start from scratch on this banner']];
    menu = el('<div class="bbd-menu" role="menu">' + items.map(function (it) {
      return '<button type="button" role="menuitem" data-m="' + it[0] + '"><strong>' + it[1] + '</strong><small>' + it[2] + '</small></button>';
    }).join('') + '</div>');
    document.body.appendChild(menu);
    var r = anchor.getBoundingClientRect();
    var mw = menu.offsetWidth;
    menu.style.top = Math.round(r.bottom + 8) + 'px';
    menu.style.left = Math.round(Math.max(8, Math.min(window.innerWidth - mw - 8, r.left + r.width / 2 - mw / 2))) + 'px';
    menu.addEventListener('click', function (e) {
      var b = e.target.closest('[data-m]');
      if (!b) return;
      var m = b.getAttribute('data-m');
      closeMenu();
      m === 'new' ? designNewBanner() : open();
    });
    menu.querySelector('button').focus();
  }
  document.addEventListener('click', function (e) {
    if (menu && !menu.contains(e.target) && !e.target.closest('#bbdNavDesign')) closeMenu();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  window.addEventListener('scroll', closeMenu, { passive: true });

  function installNav() {
    var navRow = document.getElementById('bannerSimpleNav');
    if (!navRow || document.getElementById('bbdNavDesign')) return;
    var nav = el('<button type="button" class="bbd-nav-design" id="bbdNavDesign" aria-haspopup="menu">' +
      '<span class="bbd-nav-ico" aria-hidden="true">' + ICON.design + '</span><span class="bbd-nav-label">Design Banner</span><span class="bbd-nav-short">Design</span></button>');
    var dup = document.getElementById('bannerDuplicateCurrent');
    if (dup && dup.parentNode === navRow) dup.insertAdjacentElement('afterend', nav); else navRow.appendChild(nav);
    nav.addEventListener('click', function (e) {
      e.stopPropagation();
      if (menu) return closeMenu();
      activeState() === 'empty' ? open() : showMenu(nav);
    });
  }

  function installEntry() {
    var builderRoot = document.getElementById('blazing-banner-builder-v43');
    var uploadLabel = document.getElementById('uploadLabel');
    if (!builderRoot || !uploadLabel) return;
    installNav();
    if (document.getElementById('bbdEntry')) return;

    var btn = el('<button type="button" class="bbd-entry" id="bbdEntry">' +
      '<span class="bbd-entry-ico" aria-hidden="true">' + ICON.design + '</span>' +
      '<span class="bbd-entry-copy"><strong>Design it here instead</strong><small>No file? Add text, colors, shapes and logos</small></span>' +
      '<span class="bbd-entry-go" aria-hidden="true">→</span></button>');
    uploadLabel.insertAdjacentElement('afterend', btn);
    btn.addEventListener('click', open);

    // Phones: the empty preview is already full, so the design button sits right under it.
    var actions = document.getElementById('previewActionRow');
    if (actions && !document.getElementById('bbdPhoneCta')) {
      var cta = el('<button type="button" class="bbd-phone-cta" id="bbdPhoneCta"><span aria-hidden="true">' + ICON.design + '</span>No file? <b>Design it here, free</b></button>');
      cta.addEventListener('click', function (e) { e.stopPropagation(); open(); });
      actions.insertAdjacentElement('beforebegin', cta);
    }

    var ph = document.getElementById('placeholder');
    // Wide, short banners (10 x 4, etc.) leave little height: switch the empty preview to a compact layout.
    var box = document.getElementById('bannerBox');
    if (ph && box && window.ResizeObserver && !box.__bbdFit) {
      box.__bbdFit = true;
      new ResizeObserver(function () {
        var h = box.clientHeight;
        ph.classList.toggle('bbx-ph-short', h > 0 && h < 280);
        ph.classList.toggle('bbx-ph-tiny', h > 0 && h < 150);
      }).observe(box);
    }
    if (ph && !ph.querySelector('.bbd-ph-link')) {
      var link = el('<button type="button" class="bbd-ph-link"><span aria-hidden="true">' + ICON.design + '</span><span class="bbd-ph-or">No file?</span> Design it here, free</button>');
      link.addEventListener('click', function (e) { e.stopPropagation(); open(); });
      ph.appendChild(link);
    }

    // Tab switches / new banners change which banner is active; the builder may also re-render the nav row.
    builderRoot.addEventListener('click', function () { setTimeout(function () { installNav(); refreshEntry(); }, 0); });
    // An upload finishes on its own schedule; the builder hides the empty placeholder when artwork shows.
    if (ph && window.MutationObserver) new MutationObserver(function () { refreshEntry(); }).observe(ph, { attributes: true, attributeFilter: ['style', 'hidden', 'class'] });
    refreshEntry();
  }

  if (window.BBBuilder) installEntry();
  document.addEventListener('bb:builder-ready', installEntry);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installEntry);

  window.BBDesigner = { open: open, render: render, _canvas: function () { return canvas; } };
})();
